<template>
    <div 
        class="beyond-bounds" 
        :class="{ 'animate': doAnimate }"
    >
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 682.9 682.9" style="enable-background:new 0 0 682.9 682.9;" xml:space="preserve">
            <circle id="bg" cx="341" cy="344.4" r="310.6" />
            <g class="floor">
                <path
                    class="st0"
                    d="M283.1,449.6c1.9-3.9,3.4-7.8,5.2-12.2c-12.7,0-23.8,0.1-34.8,0c-5.5-0.1-6.8,1.2-7.5,3.3
                c-0.9,2.7-2.4,5.3-3.8,7.9c-0.9,1.7-0.4,2.6,4.2,2.6c10.8-0.1,21.6,0,32.3-0.1C280.2,451,282.8,450.2,283.1,449.6z"
                />
                <path
                    class="st0"
                    d="M276.8,469.7c-11.8,0-22.6,0-33.4,0c-10.9,0-10.9,0-12.6,4.9c-0.1,0.3-0.3,0.6-0.5,1c-1.6,3.2-3.1,6.3-4.9,9.8
                c16.3,0,31.2,0,46,0C273.3,480.1,275,475,276.8,469.7z"
                />
                <path
                    class="st0"
                    d="M324.9,466.9c1,0,2.8-0.9,3-1.4c0.9-4.1,1.4-8.2,2.1-12.5c-13.3,0-26.5,0-39.7,0.1c-1.1,0-2.8,0.9-3,1.5
                c-1.4,4-2.4,8.1-3.6,12.4C297.4,467,311.1,467,324.9,466.9z"
                />
                <path
                    class="st0"
                    d="M278.7,463.5c0.1-0.6,0.8-1.2,1-1.8c1-2.8,1.9-5.6,2.9-8.4c-14.4,0-28.5,0-42.4,0c-2,4.6-3.8,9-5.9,13.8
                c12.9,0,24.4,0,35.8,0C278.2,467.1,278.1,467.1,278.7,463.5z"
                />
                <path
                    class="st0"
                    d="M212.5,423.7c-1.1,0-2.7,0.8-3.1,1.4c-2,3.3-3.6,6.7-5.5,10.3c13.4,0,26.5,0,39.7,0c1.8-3.8,3.5-7.6,5.5-11.7
                C236.2,423.6,224.3,423.6,212.5,423.7z"
                />
                <path
                    class="st0"
                    d="M330.2,450c1.3-4.1,2.2-8.1,3.3-12.5c-14.1,0-26.6,0-40.1,0c-1.4,3.8-2.8,7.7-4,11.5c-0.4,1.1,0,2.1,3.5,2.1
                c11.3-0.1,22.6,0,34-0.1C328,451,330.1,450.4,330.2,450z"
                />
                <path
                    class="st0"
                    d="M259.6,423.6c-4.9-0.1-6.4,1-7.1,3c-1,2.9-2.3,5.8-3.5,8.8c13.3,0,26.7,0,40,0c1.2-3.9,2.2-7.7,3.4-11.7
                C281,423.6,270.3,423.7,259.6,423.6z"
                />
                <path
                    class="st0"
                    d="M51.5,447.2c1.5-1.4,2.9-2.7,4.2-4.1c1.7-1.8,3.1-3.6,4.9-5.6c-4.3,0-8.5,0-12.5,0.1
                C49.2,440.7,50.3,444,51.5,447.2z"
                />
                <path
                    class="st0"
                    d="M138.7,531.4c-14,0-27,0-40,0c5.9,7.5,12.2,14.7,18.7,21.6c1.8,0,3.7,0,5.5,0c1.5,0,3.6-1.2,4.2-2
                c3-4.2,5.7-8.5,8.3-12.8C136.8,536.1,137.6,533.9,138.7,531.4z"
                />
                <path
                    class="st0"
                    d="M265.6,503.1c0.3-1.5,1.1-3,1.5-4.5c1-3.3,2-6.7,3-10.4c-14.4,0-27.7,0.1-41,0c-4.8,0-6.2,1.1-6.8,2.9
                c-0.9,2.3-1.5,4.6-2.5,6.9c-0.8,1.9-1.3,3.8-2.9,5.6c-1.8,1.9-0.5,2.4,3.4,2.4c13,0,25.9,0,38.9,0
                C263.4,505.9,265.3,505,265.6,503.1z"
                />
                <path
                    class="st0"
                    d="M69.5,437.5c-1.7,0-3.9,0.9-4.9,1.7c-2.4,1.8-4.3,3.7-6.1,5.6c-1.9,2-3.4,4-5.4,6.4c13.8,0,26.4,0,38.9,0
                c1,0,2.4-0.6,2.9-1c2.3-2.2,4.4-4.4,6.4-6.6c1.7-1.9,3.1-3.7,5-6C93.1,437.4,81.3,437.3,69.5,437.5z"
                />
                <path
                    class="st0"
                    d="M158.7,435.4c14.1,0,26.9,0,39.8,0c2.4-3.9,4.7-7.7,7.1-11.6c-13.8,0-26.5,0-38.8,0
                C164,427.8,161.5,431.4,158.7,435.4z"
                />
                <path
                    class="st0"
                    d="M259.2,520.8c1.3-3.3,2.5-6.6,3.8-10c0.6-1.5,0.7-2.6-3.8-2.6c-13.3,0-26.6,0-39.9,0.1c-1.9,0-5.1,0.9-5.4,1.7
                c-2.9,5.8-5.3,11.6-7.9,17.6c17.2,0,33.9,0,50.6,0C257.5,525.2,258.3,523,259.2,520.8z"
                />
                <path
                    class="st0"
                    d="M184,553.1c1.2,0,3.2-0.6,3.5-1.1c1.1-1.6,1.6-3.3,2.4-4.9c1.2-2.4,2.6-4.8,3.7-7.2c1.2-2.7,2.1-5.4,3.3-8.5
                c-16.8,0-32.6,0-48.4,0.1c-1.3,0-3.3,0.8-3.7,1.4c-3.1,4.8-6,9.7-8.8,14.5c-1,1.8-1.7,3.5-2.7,5.7C151,553.1,167.5,553.1,184,553.1
                z"
                />
                <path
                    class="st0"
                    d="M114.5,437.5c-1.6,0-3.7,0.9-4.5,1.6c-2.3,2.2-4.2,4.4-6,6.7c-1.3,1.6-2.2,3.3-3.3,5.2c14.5,0,27.7,0,41,0
                c3.4-4.5,6.6-8.8,10.2-13.5C138.6,437.4,126.5,437.3,114.5,437.5z"
                />
                <path
                    class="st0"
                    d="M331.8,506c11.9-0.1,23.7-0.1,35.6,0c5,0.1,6.4-0.7,6.4-2.9c0-4.4,0.9-8.8,1.1-13.1c0-0.5-2.1-1.5-3.3-1.5
                c-14.2-0.1-28.4-0.1-43.2-0.1c-0.9,5.2-1.5,10-2.6,14.8C325.5,505.2,327,506,331.8,506z"
                />
                <path
                    class="st0"
                    d="M315,526.3c1-5.3,1.8-10.7,2.6-16c0.2-1.5-1.2-2-4.4-2c-12.9,0-25.9,0-38.8,0c-2.7,0-4.3,0.3-4.8,1.7
                c-1,2.9-2.7,5.8-3.7,8.7c-1,2.9-1.6,5.9-2.5,9.1c16.5,0,32.6,0,48.8-0.1C313.1,527.7,314.9,526.8,315,526.3z"
                />
                <path
                    class="st0"
                    d="M319.7,503.4c0-1.9,0.4-3.9,0.7-5.8c0.6-3,1.3-6,2-9.2c-15.9,0-30.6,0-46.3,0c-1.5,5.2-2.8,10.3-4.5,15.3
                c-0.6,1.6,0.2,2.3,3.8,2.3c12.9,0,25.9,0,38.8,0C317.9,505.9,319.8,505.2,319.7,503.4z"
                />
                <path
                    class="st0"
                    d="M382.2,553.1c14.2,0,28.4-0.1,42.7,0c4.5,0,5.4-0.8,5.3-2.6c-0.3-5.5-0.2-10.9-0.3-16.4c0-3-0.5-3.3-7.4-3.3
                c-14,0.1-28,0.3-42,0.5c-0.7,0-1.4,0.1-2.3,0.2c-0.1,0.6-0.3,1.1-0.3,1.7c-0.3,6-0.5,11.9-0.8,17.9
                C377,552.9,379.1,553.1,382.2,553.1z"
                />
                <path
                    class="st0"
                    d="M374.5,451c1.2,0,3.3-0.7,3.3-1.1c0.2-4.1,0.2-8.2,0.2-12.4c-13.1,0-25.7,0-39.6,0c-0.6,4-1.1,7.8-1.6,11.5
                c-0.2,1.2,0.4,2,3.7,2C351.8,451,363.2,451,374.5,451z"
                />
                <path
                    class="st0"
                    d="M378.5,453c-13.6,0-26,0.1-38.4,0c-4.3,0-5.4,0.7-5.5,2.6c-0.2,2.8-1.2,5.6-1.7,8.5c-0.2,0.9,0,1.9,0,2.9
                c14.6,0,28.7,0,43.3,0C376.9,462.3,377.7,457.8,378.5,453z"
                />
                <path
                    class="st0"
                    d="M375.6,469.9c-14.5,0-28.7,0-43.5,0c-0.9,5.2-1.8,10.3-2.6,15.4c15.7,0,30.8,0,46.2,0
                C375.6,480,375.6,475,375.6,469.9z"
                />
                <path
                    class="st0"
                    d="M43.9,423.7c1.1,4,2.3,7.9,3.6,11.8c4.4,0,8.8,0,13.1,0c1.2,0,3-0.4,3.5-0.9c3.7-3.5,7-7.1,10.8-11
                C64.2,423.6,54,423.6,43.9,423.7z"
                />
                <path
                    class="st0"
                    d="M113.4,435.5c10.3,0,19.1-0.1,27.9,0c7.4,0.2,13.8,0.2,15.4-4.2c0.9-2.6,3.5-5,5.4-7.6c-13.3,0-26,0-38.6,0
                C120.1,427.6,116.9,431.3,113.4,435.5z"
                />
                <path
                    class="st0"
                    d="M174.5,579.5c1.7-3.2,3.2-6.4,4.6-9.6c1.7-3.8,2.5-7.7,5.1-11.3c1.6-2.3-0.3-2.3-3.8-2.3
                c-14.8,0-29.5,0-44.3,0c-4.1,0-6,0.8-6.8,2.7c-0.6,1.4-1.3,2.7-2,4.1c6.4,6.2,13.1,12.1,20,17.7c8,0,15.9,0,23.9,0
                C172.3,580.7,174.2,580,174.5,579.5z"
                />
                <path
                    class="st0"
                    d="M90.9,423.5c-7.6-0.3-12.7,0.4-15.2,4c-1.8,2.6-4.7,5.1-7.4,7.9c12.9,0,25,0.1,37-0.1c1.6,0,3.8-0.9,4.5-1.6
                c3.1-3.3,5.7-6.6,8.8-10.2C109.1,423.6,99.9,423.9,90.9,423.5z"
                />
                <path
                    class="st0"
                    d="M231.7,580.7c6.9,0,7.4-0.3,8.1-3.4c0.7-3.2,1.9-6.4,3-9.6c1.1-3.2,2.3-6.4,3.4-9.5c0.4-1.2-0.5-2-3.8-2
                c-15.5,0.1-30.9,0-46.4,0.1c-1.2,0-3.1,0.3-3.5,0.7c-1.2,1.3-1.9,2.8-2.5,4.2c-2,4.1-4,8.3-5.9,12.4c-1,2.3-1.8,4.5-2.9,7.1
                c2.5,0,4.4,0,6.4,0C202.2,580.7,216.9,580.7,231.7,580.7z"
                />
                <path
                    class="st0"
                    d="M313.7,531.4c-17,0-32.7,0-48.3,0c-3.4,0-3.9,0.8-4.3,2.2c-1,3.6-2.6,7.1-3.7,10.7c-0.9,2.8-1.5,5.7-2.2,8.7
                c17.9,0,35.5,0,53.6,0C310.3,545.8,312,538.8,313.7,531.4z"
                />
                <path
                    class="st0"
                    d="M248.4,551.3c1.1-3.2,2.7-6.3,3.8-9.5c1.1-3.3,1.9-6.7,3-10.4c-16.8,0-32.4,0-48.1,0.1c-1.4,0-3.6,0.6-3.9,1.2
                c-1.2,1.8-1.7,3.8-2.5,5.7c-1.6,3.8-3.1,7.6-4.8,11.3c-0.5,1-1.3,2.1-1.9,3c1.1,0.3,1.4,0.4,1.7,0.4c16.4,0,32.8,0,49.1,0.1
                C248,553.2,248.1,552.3,248.4,551.3z"
                />
                <path
                    class="st0"
                    d="M326.5,469.8c-15,0-29.1,0-44.2,0c-1.6,5.1-3.2,10.2-4.8,15.6c15.9,0,30.7,0,45.8,0
                C324.4,480.1,325.5,475,326.5,469.8z"
                />
                <path
                    class="st0"
                    d="M382.6,454c-0.2,4.3-0.1,8.6-0.1,12.9c14.6,0,28.5,0,42.8,0c0-4.7,0-9.2,0-13.9c-13.4,0-26.5,0-39.6,0
                C384.6,453.1,382.7,453.7,382.6,454z"
                />
                <path
                    class="st0"
                    d="M386.9,450.9c11.7,0.1,23.3,0.1,35,0c1.2,0,3.5-1,3.5-1.6c-0.1-3.9-0.6-7.9-1-11.8c-14,0-26.7,0-39.5,0
                c-0.5,4.1-1.2,7.9-1.4,11.7C383.4,449.8,385.6,450.9,386.9,450.9z"
                />
                <path
                    class="st0"
                    d="M384.6,435.4c13.1,0,25.8,0,38.6,0c0-3.9,0-7.7,0-11.6c-13,0-25.7,0-38.6,0
                C384.6,427.7,384.6,431.4,384.6,435.4z"
                />
                <path
                    class="st0"
                    d="M380.4,490c-0.3,4.7-0.2,9.3-0.3,14c0,1.4,1.3,1.9,4.2,1.9c13.1,0,26.3,0,39.4-0.1c1.4,0,3.9-0.9,4-1.4
                c0.3-5.3,0.2-10.6,0.2-16.2c-15.3,0-30,0-44.7,0.1C382.1,488.4,380.4,489.4,380.4,490z"
                />
                <path class="st0" d="M120.6,556.3c0.8,0.8,1.5,1.5,2.3,2.3C123.6,557.4,122.9,556.6,120.6,556.3z" />
                <path
                    class="st0"
                    d="M475.7,466.9c-1.1-4.8-2.1-9.2-3.2-13.9c-12.9,0-25.8,0-38.7,0c-4.3,0-3.8,1.3-3.6,2.5
                c0.5,2.8,1.1,5.7,1.6,8.5c0.2,0.9,0,1.9,0,2.9C446.6,466.9,460.6,466.9,475.7,466.9z"
                />
                <path
                    class="st0"
                    d="M378.4,518.5c-0.3,3-0.1,6-0.1,9.1c17.1,0,33.9,0,51.7,0c-0.8-6.2-1.4-12.1-2.5-17.9c-0.1-0.5-2.8-1.4-4.3-1.4
                c-13-0.1-25.9,0-38.9-0.1c-3.2,0-4.4,0.5-4.6,2C379.6,513,378.7,515.7,378.4,518.5z"
                />
                <path
                    class="st0"
                    d="M384,421.6c13.8,0,26.4,0,39.1,0c0-3.6,0-7.1,0-10.7c-12.4,0-24.5,0-36.7,0C385.6,414.5,384.9,417.9,384,421.6
                z"
                />
                <path
                    class="st0"
                    d="M369.4,558.5c0.1-1.2,0.2-2.3-3.7-2.3c-15.6,0.1-31.3,0-47,0.1c-1.2,0-3.2,0.8-3.4,1.3c-1,3.1-1.5,6.3-2.3,9.4
                c-0.5,1.9-1.3,3.8-1.5,5.8c-0.3,2.6-0.1,5.1-0.1,7.8c18.5,0,36.8,0,56.2,0c0-2.3-0.2-4.4,0-6.5
                C368.2,568.9,368.8,563.7,369.4,558.5z"
                />
                <path
                    class="st0"
                    d="M367.1,586.4c0-0.6-2.4-1.6-3.7-1.7c-16.4-0.1-32.7-0.1-49.1-0.1c-3.7,0-5.6,0.8-5.5,2.5c0,2,0,4.1-0.5,6.1
                c-1.2,5.6-2.5,11.3-3.9,16.9c-0.5,1.9,1.2,2.7,5.5,2.6c8.3-0.1,16.5,0,24.8,0c8.5,0,16.9-0.1,25.4,0c3.7,0,5.2-0.5,5.1-2.3
                c-0.1-3.1,0.1-6.2,0.4-9.3C366,596.3,366.8,591.4,367.1,586.4z"
                />
                <path
                    class="st0"
                    d="M498.9,587.6c-0.3-1.9-1.9-3-6.6-2.9c-15.5,0.1-31,0.1-46.5,0c-4.5,0-5.5,0.8-5.4,2.6
                c0.7,7.7,1.4,15.5,1.9,23.2c0.1,1.8,1.8,2.4,5.6,2.4c8.1-0.1,16.2,0,24.3,0c6.1,0,12.2,0,18.4,0c3.7-2,7.4-4.1,11-6.3
                c-0.1-0.2-0.1-0.4-0.2-0.7C500.5,599.8,499.7,593.7,498.9,587.6z"
                />
                <path
                    class="st0"
                    d="M381.1,483.1c-0.7,2.1,0.5,2.5,4.4,2.4c12.4,0,24.8,0,37.3,0c1.5,0,3-0.2,4.9-0.3c-0.9-5.3-1.7-10.3-2.5-15.4
                c-14.3,0-28.4,0-43.1,0c0,1.1,0.1,2.1,0,3C381.9,476.3,382.2,479.7,381.1,483.1z"
                />
                <path
                    class="st0"
                    d="M219.4,616.9c-5.4,0-10.7,0-16.1,0.1c6.2,3.1,12.6,6.1,19,8.8c0.8-2.1,1.6-4.2,2.3-6.3
                C225.3,617.6,223.8,616.9,219.4,616.9z"
                />
                <path
                    class="st0"
                    d="M235.8,587c0.7-2-0.9-2.3-4.4-2.3c-16,0-32,0-48,0c-2.8,0-4.1,0.4-4.7,1.7c-1.9,4.3-4.2,8.6-6.2,12.8
                c7.4,4.9,15,9.4,22.8,13.6c0.5,0,1,0,1.4,0c7.9,0,15.8-0.1,23.7,0c5.4,0.1,7.4-1.1,8.2-3.2c0.7-2.1,1.5-4.1,2.1-6.2
                C232.5,598,233.8,592.5,235.8,587z"
                />
                <path
                    class="st0"
                    d="M159.8,437.5c-1.5,0-3.7,0.8-4.2,1.4c-2.9,3.9-5.3,7.8-8.3,12.2c13.4,0,25.7,0.1,38.1-0.1
                c1.6,0,3.6-1.2,4.5-2.1c1.6-1.6,2.7-3.4,3.7-5.1c1.2-2,2.1-4.1,3.2-6.4C183.9,437.4,171.8,437.3,159.8,437.5z"
                />
                <path
                    class="st0"
                    d="M167.2,505.9c12.2,0,24.4-0.1,36.7,0.1c5.1,0.1,6.6-1.2,7.5-2.9c1.6-2.9,3-5.9,4.3-8.9
                c0.8-1.9,1.4-3.8,2.2-5.9c-14.8,0-29,0-43.1,0.1c-1.4,0-3.5,0.6-4,1.2c-1.3,1.6-1.7,3.2-2.6,4.9c-1.7,2.9-3.1,5.9-5.3,8.7
                C161.1,505.5,161.4,505.9,167.2,505.9z"
                />
                <path
                    class="st0"
                    d="M157,503.4c1.1-1.5,1.9-3.1,2.8-4.6c1.9-3.4,3.9-6.7,5.9-10.3c-15.5,0-31,0-46,0c-3.9,5.1-7.5,9.9-11.3,14.7
                c-1.5,1.8-0.4,2.7,4.1,2.7c12.1,0,24.1-0.2,36.2,0.1C153.6,506.1,155.7,505.2,157,503.4z"
                />
                <path
                    class="st0"
                    d="M147.1,518.3c1.7-2.7,3.9-5.4,5.8-8.1c1-1.4-0.6-2-3.6-2c-13.3,0-26.6-0.1-39.9,0.1c-2,0-5,0.9-5.6,1.6
                c-3.7,4.7-7,9.4-10.4,14.3c0.8,1.1,1.7,2.3,2.5,3.4c15.4,0,30.7,0,46.1,0C143.7,524.4,145.2,521.3,147.1,518.3z"
                />
                <path
                    class="st0"
                    d="M237.6,447.4c0.1-0.5,0.9-1,1.1-1.6c1.2-2.7,2.4-5.4,3.7-8.4c-13.2,0-25.4-0.1-37.6,0.1c-1.4,0-3.3,1.3-4,2.1
                c-1.7,2.1-2.8,4.2-4,6.4c-0.9,1.6-1.5,3.2-2.3,5.1c11.8,0,23.1,0,34.4,0C236.7,451.1,236.7,451,237.6,447.4z"
                />
                <path
                    class="st0"
                    d="M53.8,453.1c1.9,4.9,4,9.8,6.2,14.6c5.1,0,10.1,0,15.2,0c3.8,0,5.6-0.8,6.9-2.4c3.2-3.9,6.8-7.8,10.6-12.1
                C79.4,453,66.6,453,53.8,453.1z"
                />
                <path
                    class="st0"
                    d="M235.1,453.1c-14.4,0-28.3,0-42.4,0c-2.7,4.7-5.2,9.1-7.9,13.7c15.3,0,29.6,0,43.5,0
                C230.7,462.2,232.9,457.7,235.1,453.1z"
                />
                <path
                    class="st0"
                    d="M227.2,469.7c-14.4,0-27.7-0.1-40.9,0.1c-1.7,0-4,1.5-4.9,2.5c-1.7,1.9-2.7,3.9-3.8,5.9
                c-1.3,2.3-2.3,4.7-3.4,7.1c16,0,30.8,0,45.4,0C222.1,480.1,224.5,475.1,227.2,469.7z"
                />
                <path
                    class="st0"
                    d="M99.9,453.1c-1,0-2.5,0.7-3,1.2c-3.2,3.6-6.1,7.2-9.2,10.8c-1.9,2.3-1.7,2.5,3.9,2.5c10.4,0,20.9-0.1,31.3,0
                c5.5,0.1,7.3-1.2,8.7-3.3c2.4-3.7,5.3-7.3,8.4-11.4C126.5,453,113.2,453,99.9,453.1z"
                />
                <path
                    class="st0"
                    d="M109.8,493.8c1.3-1.7,1.9-3.4,3-5.4c-14.7,0-28.5,0-42.5,0c3.3,6,6.7,11.8,10.4,17.6c5.1,0,10.2,0,15.4-0.1
                c1.8,0,4.5-0.9,5.3-1.7C104.5,500.8,107.2,497.3,109.8,493.8z"
                />
                <path
                    class="st0"
                    d="M127.7,469.7c-14.3,0-27.9-0.1-41.5,0.1c-1.5,0-3.4,1-4.2,1.7c-2.2,2.1-4,4.3-5.9,6.5c-2,2.4-3.8,4.8-5.8,7.4
                c15.9,0,30.6,0,45.7,0C119.8,480.2,123.6,475.1,127.7,469.7z"
                />
                <path
                    class="st0"
                    d="M92.4,508.2c-3.4,0-6.8,0-10.3,0c2.6,4,5.2,7.9,8,11.7c2.3-3,4.7-6.1,6.7-9.2C98,509.2,96.8,508.2,92.4,508.2z
                "
                />
                <path
                    class="st0"
                    d="M187.6,453.2c-14.4,0-28.6,0-42.3,0c-2.8,4-5.3,7.8-8.3,11.5c-1.8,2.3-1.3,2.9,4.1,2.9c12.4,0,24.7,0,37.4,0
                C181.9,462.3,184.7,457.8,187.6,453.2z"
                />
                <path
                    class="st0"
                    d="M177.4,469.7c-14.4,0-27.7-0.1-41,0.1c-1.7,0-4,1.2-4.7,2c-2.4,2.6-4.3,5.3-6.2,8c-1.2,1.8-2.1,3.6-3.1,5.5
                c15.8,0,30.8,0,45.4,0C171,480.1,174.1,475.1,177.4,469.7z"
                />
                <path class="st0" d="M78,469.7c-5.8,0-11.5,0-17.1,0c1.9,4.2,4,8.3,6.1,12.4C70.5,478.1,74.2,474,78,469.7z" />
                <path
                    class="st0"
                    d="M200.3,526c1.2-1.9,1.8-3.9,2.7-5.9c1.2-2.5,2.2-5,3.9-7.4c2.3-3.2,0.5-4.5-7-4.5c-11.1,0-22.3,0-33.4,0
                c-6.2,0-7.7,0.8-9,3.6c-1.6,3.2-3.9,6.4-5.8,9.6c-1.1,2-2,4-3.2,6.3c16.5,0,32.3,0,48.1-0.1C197.8,527.7,199.8,526.7,200.3,526z"
                />
                <path
                    class="st0"
                    d="M293.6,435.5c12.9,0,25.5,0,38.1,0c1,0,2.8-0.6,2.9-1c0.7-3.5,1.2-7,1.7-10.7c-12.6,0-25.3,0-38.2,0
                C296.5,427.6,295.1,431.4,293.6,435.5z"
                />
                <path
                    class="st0"
                    d="M298.3,421.6c13,0,25.7,0,38.2,0c1-3.7,2-7.1,3-10.7c-12.8,0-24.6,0-37.3,0C300.9,414.5,299.6,418,298.3,421.6
                z"
                />
                <path
                    class="st0"
                    d="M261.9,410.9c-1,0-2.5,0.9-2.7,1.4c-1.4,3-2.6,6.1-3.9,9.3c12.6,0,25.4,0,38.2,0c1.2-3.5,2.3-7,3.6-10.7
                C285.1,410.8,273.5,410.8,261.9,410.9z"
                />
                <path
                    class="st0"
                    d="M375.7,435.4c1.3,0,3.7-0.9,3.8-1.5c0.4-3.4,0.2-6.8,0.2-10.2c-12.8,0-25.5,0-38,0c-1,3.9-2,7.6-3.1,11.8
                C351.7,435.5,363.8,435.5,375.7,435.4z"
                />
                <path
                    class="st0"
                    d="M211.7,421.6c13,0,25.6,0,38.4,0c1.7-3.6,3.4-7.1,5.2-10.8c-13.1,0-24.9,0-37,0
                C216.2,414.4,214.1,417.9,211.7,421.6z"
                />
                <path
                    class="st0"
                    d="M125.3,421.7c12.9,0,25.4,0,38.4,0c2.5-3.5,5-7,7.8-10.7c-13.3,0-25.3,0-37,0
                C131.3,414.6,128.4,418,125.3,421.7z"
                />
                <path
                    class="st0"
                    d="M178.7,410.9c-1.4,0-3.2,1.2-3.8,1.9c-2.3,2.8-4.1,5.8-6.2,8.8c12.8,0,25.4,0,38.2,0c2.2-3.5,4.4-7,6.8-10.8
                C201.8,410.8,190.3,410.7,178.7,410.9z"
                />
                <path
                    class="st0"
                    d="M511.6,410.9c0.9,3.5,1.7,6.7,2.8,10c0.1,0.4,2.1,0.9,3.2,0.9c11.6,0.1,23.3,0,35.9,0
                c-1.8-3.7-3.4-7.2-5.1-10.9C536.2,410.9,524.2,410.9,511.6,410.9z"
                />
                <path
                    class="st0"
                    d="M507.4,423.6c-11.3-0.1-22.6-0.1-35-0.1c0.6,4.2,1.2,8,1.8,11.8c14.1,0,26.8,0,40.2,0
                c-0.9-3.6-1.7-7.1-2.9-10.6C511.3,424.3,508.9,423.6,507.4,423.6z"
                />
                <path
                    class="st0"
                    d="M97.3,410.8c-3.9,0-5.6,0.8-6.9,2.3c-2.5,2.9-5.4,5.7-8.3,8.6c12.9,0,25.5,0,38.2,0c3.1-3.5,6.2-7,9.7-10.9
                C118.5,410.8,107.9,410.9,97.3,410.8z"
                />
                <path
                    class="st0"
                    d="M506.1,411.3c-2.6-0.9-7.5-0.5-11.4-0.5c-3.2-0.1-6.5,0-9.7,0c-5.2,0-10.3,0-14.2,0c0,3.5-0.2,6.3,0.1,9.1
                c0.1,0.7,1.7,1.8,2.7,1.9c12,0.1,23.9,0.1,37,0.1c-1.1-2.1-2.1-3.9-2.7-5.7C507.2,414.4,508.2,412,506.1,411.3z"
                />
                <path
                    class="st0"
                    d="M431.6,580.6c0-7.5,0.2-14.8-0.2-22.2c0-0.7-3.3-2-5.1-2.1c-15.1-0.2-30.2-0.2-45.3,0c-1.7,0-4.8,1.2-4.9,1.9
                c-0.3,7.4-0.2,14.8-0.2,22.4C394.9,580.6,413.3,580.6,431.6,580.6z"
                />
                <path class="st0" d="M428,410.8c0,3.6,0,7.1,0,10.8c13,0,25.7,0,39.3,0c-1-3.7-2-7.2-3-10.8C452,410.8,440.2,410.8,428,410.8z" />
                <path
                    class="st0"
                    d="M428.3,423.8c0.7,4,1.3,7.8,2,11.6c12.9,0,25.4,0,39.3,0c-0.8-4.1-1.6-7.8-2.4-11.6
                C453.6,423.8,441,423.8,428.3,423.8z"
                />
                <path
                    class="st0"
                    d="M341.6,421.6c12.8,0,25.5,0,38.2,0c0-3.7,0-7.2,0-10.6c-12.4,0-24.3,0-35.9,0
                C343.1,414.6,342.4,417.9,341.6,421.6z"
                />
                <path
                    class="st0"
                    d="M435.8,633.5c-0.5-4.6-1.3-9.1-1.3-13.7c0-2.2-1.3-3-6.4-2.9c-16.4,0.1-32.8,0.1-49.2,0
                c-3.7,0-5.7,0.3-5.9,2.2c-0.3,4.3-1,8.6-1.5,12.9c-0.1,1-0.3,2.1-0.4,3.1c-7.6,0.5-8.2,0.4-7.9-2.8c0.4-4.3,1-8.6,1.8-12.9
                c0.3-2-1.3-2.5-5.5-2.5c-16.7,0.1-33.5,0.1-50.2,0c-4.7,0-6.7,0.7-6.9,3c-0.5,4.5-1.5,9.1-2.2,13.6c-0.4,2.6-4.3,1.8-8.1,1.8
                c0-1.7-0.3-3.3,0.1-4.8c0.9-3.9,2.3-7.9,3-11.8c0.1-0.5-2.6-1.6-4.1-1.6c-17.8-0.1-35.7-0.1-53.5,0c-1.4,0-3.9,0.8-4.1,1.4
                c-1.3,3.5-2.5,6.9-3.5,10.4c35.1,13.7,73.2,21.3,113.2,21.3c33,0,64.9-5.2,94.8-14.7C436.3,635.2,435.9,634.3,435.8,633.5z"
                />
                <path
                    class="st0"
                    d="M442.6,633.8c13.8-4.7,27.2-10.3,40.1-16.8c-11.3,0-22.6,0-33.9-0.1c-4.7,0-6.4,0.5-6.2,2.7
                c0.4,4.5,0.5,9,0.3,13.5C442.8,633.3,442.7,633.6,442.6,633.8z"
                />
                <path
                    class="st0"
                    d="M442,553c15.1,0.1,30.2,0.1,45.3,0.1c3.1,0,4.3-0.5,4-2.1c-1.2-5.6-2.1-11.3-2.9-17c-0.4-2.8-0.9-3.2-7.2-3.2
                c-12.2,0-24.4,0-36.7,0c-2.6,0-5.2,0.3-8.9,0.6c0.9,7,1.7,13.6,2.8,20.1C438.4,552.1,440.7,553,442,553z"
                />
                <path
                    class="st0"
                    d="M509.8,584.7c-3.3,0-4.7,0.5-4.3,2c0.6,2.2,1.5,4.5,1.9,6.7c0.5,2.9,1,5.8,1.4,8.8
                c8.6-5.4,16.8-11.3,24.8-17.5C525.7,584.7,517.7,584.7,509.8,584.7z"
                />
                <path
                    class="st0"
                    d="M44.8,412.6c3.6-3.4,7.3-6.7,11.3-10c0.9-0.7,3-1.2,4.5-1.7H38.4c1,4.8,2.1,9.6,3.3,14.4
                C42.7,414.4,43.8,413.5,44.8,412.6z"
                />
                <path
                    class="st0"
                    d="M61.7,401.5c-2.6,2.4-5.3,4.7-8.5,7.6c3,0,5.4,0,7.7,0c6.1,0,12.2,0,18.4,0c11.5,0,11.2-0.1,15.8-4.8
                c1-1,0.3-3.5,6.8-2.8c-2.3,2.5-4.5,4.8-7.1,7.6c2.6,0,5.1,0,7.7,0c8.1,0,16.2-0.1,24.3,0c4.2,0.1,5.9-0.8,7-2.5
                c1.1-1.6,2.7-3.2,4.4-4.7c0.4-0.3,1.9-0.4,2.9-0.6c0.4,0.5,1.3,1.1,1,1.4c-1.7,2-3.6,4-5.9,6.4c12,0,23.3,0.1,34.5-0.1
                c1.4,0,3.3-1.1,4-1.8c1.3-1.4,1.5-2.9,2.8-4.3c0.8-0.8,3-1.2,4.6-1.9c0.4,0.2,0.8,0.3,1.2,0.5c-1.6,2.4-3.3,4.7-5.2,7.6
                c7.2,0,13.4,0,19.6,0c2.3,0,4.7,0,7,0c11.8,0,12-0.1,13.4-5.5c0.4-1.8,1.9-2.6,5.8-2.2c-1.4,2.5-2.8,4.9-4.3,7.5
                c2.5,0.1,4.1,0.1,5.6,0.1c10.4,0,20.8,0,31.2,0c1-2.4,1.7-4.6,2.9-6.8c0.3-0.5,2.2-0.9,3.4-1.3c0.5,0.2,0.9,0.3,1.4,0.5
                c-1,2.4-2,4.8-3,7.4c12.4,0,24.5,0,36.7,0c0.8-2.3,1.5-4.5,2.6-6.7c0.2-0.5,2-0.8,3-1.1c0.5,0.2,1,0.3,1.5,0.5
                c-0.7,2.4-1.5,4.9-2.2,7.4c12,0,24,0,36.2,0c0.8-2.3,1.5-4.5,2.6-6.7c0.2-0.5,1.9-0.8,2.9-1.1c0.4,0.1,0.8,0.3,1.2,0.4
                c-0.2,2.4-0.5,4.8-0.7,7.6c11.2,0,22.4,0.1,33.7-0.1c1.1,0,2.8-1.3,3.1-2.2c0.6-1.3,0.2-2.8,0.6-4.1c0.2-0.6,1.4-1.1,2.2-1.7
                c0.6,0.1,1.2,0.2,1.8,0.3c0,2.5,0,5,0,7.6c12.5,0,24.4,0,36.7,0c0-2.2-0.2-4.2,0.1-6.2c0.1-0.5,1.5-1,2.3-1.5c0.7,0.5,2,0.9,2,1.4
                c0.2,2,0.1,4.1,0.1,6.3c12.3,0,24.3,0,37.3,0c-0.7-2.5-1.4-4.9-2.1-7.3c4.7-0.4,5.6-0.1,5.9,2.6c0.1,1.5,0,3.1,0,4.8
                c12.5,0,24.4,0,37.5,0c-0.9-2.6-1.8-5-2.8-7.9c1.9,0.3,3.8,0.4,4.2,0.7c1.1,1.1,2.1,2.3,2.2,3.4c0.3,4.1-0.8,3.8,9.1,3.8
                c9.1,0,18.3,0,28.5,0c-1-2.7-1.9-5.1-3-7.9c1.7,0.1,3.7,0,3.9,0.3c1.1,1.2,2.2,2.4,2.5,3.6c0.9,3.9,0.7,3.9,9.2,3.9
                c9.7,0,19.4,0,29.2,0c-1.4-2.7-2.7-5.1-4-7.5c0.5-0.2,1-0.4,1.6-0.6c1,0.4,2.5,0.8,2.9,1.3c1.8,2.2,3.2,4.5,4.8,6.6
                c12.3,0,24.2,0,36.5,0c-1.7-2.6-3.3-5-5-7.5c4.9-0.1,4.9-0.1,10.1,7.5c3.3,0,6.5,0,9.8,0c0.6-2.7,1.2-5.3,1.7-8H60.7
                C61,401.1,61.4,401.3,61.7,401.5z"
                />
                <path
                    class="st0"
                    d="M587.4,410.8c-11.3-0.1-22.5,0-34.8,0c1.1,1.4,2,2.3,2.4,3.2c0.9,2.2,1.4,4.4,2.5,6.6c0.2,0.5,2.1,1.2,3.2,1.2
                c11.8,0.1,23.6,0.1,36.2,0.1c-2-3.5-3.7-6.7-5.8-9.9C590.7,411.4,588.6,410.8,587.4,410.8z"
                />
                <path
                    class="st0"
                    d="M52.7,410.9c-1.1,0-2.6,0.8-3.3,1.3c-2.4,2-4.6,4-7,6.1c0.3,1.1,0.6,2.2,0.9,3.3c11.4,0,22.5,0,33.7,0
                c3.6-3.5,7.1-6.9,11.1-10.8C75.9,410.8,64.3,410.8,52.7,410.9z"
                />
                <path
                    class="st0"
                    d="M437,527.6c16.1,0,32.4,0,49.7,0c-1-5.7-2.1-11.1-2.7-16.6c-0.2-2.1-1.9-2.9-6.4-2.9c-12.4,0-24.8,0.1-37.2,0
                c-4.5,0-6.6,0.6-6.3,2.9c0.9,5.3,1.5,10.7,2.2,16.1C436.4,527.3,436.7,527.4,437,527.6z"
                />
                <path
                    class="st0"
                    d="M241.3,612.8c8.1,0,16.2,0,24.3,0c8.5,0,16.9,0.1,25.4-0.1c1.7,0,4.2-0.6,4.9-1.2c1.2-1.1,1.6-2.5,1.9-3.8
                c1.6-6.9,3-13.9,4.5-20.8c0.3-1.3-0.2-2.3-3.8-2.3c-16.7,0-33.5,0-50.2,0.1c-1.4,0-3.8,0.8-4,1.4c-1.7,3.8-3,7.6-4.3,11.4
                c-1.4,4.1-2.6,8.1-4.2,12.2C234.6,612.2,235.6,612.8,241.3,612.8z"
                />
                <path
                    class="st0"
                    d="M378.5,612.8c8.5-0.1,16.9,0,25.4,0c8.3,0,16.5-0.1,24.8,0c4.3,0.1,5.7-0.7,5.5-2.6c-0.8-7.9-1.4-15.8-2-23.7
                c-0.1-1.7-2.1-1.9-5.2-1.9c-15.3,0-30.6,0.1-45.9,0c-5.2,0-7.2,1-7.2,3.1c-0.2,7.6-0.3,15.2-0.6,22.8
                C373.3,612.3,374.9,612.9,378.5,612.8z"
                />
                <path
                    class="st0"
                    d="M163.4,584.7c-3.7,0-7.4,0-11.2,0c4.7,3.7,9.6,7.2,14.5,10.6c1-2.1,2.1-4.2,3.3-6.3
                C172.1,585.8,170.7,584.7,163.4,584.7z"
                />
                <path
                    class="st0"
                    d="M304.2,576.7c1-5.5,1.8-11,2.7-16.5c0.1-0.4-0.1-0.9,0.3-1.2c2.3-2.5-0.9-2.8-5.1-2.8c-14,0-28.1,0-42.1,0
                c-6.2,0-6.7,0.4-7.5,3.3c-0.9,3.6-2.5,7.1-3.7,10.7c-1.1,3.4-1.9,6.8-2.9,10.4c19.1,0,37.4,0,56.3,0
                C302.9,579.3,304,578,304.2,576.7z"
                />
                <path
                    class="st0"
                    d="M370,546.1c0.7-4.8,1.4-9.5,2.2-14.7c-17.3,0-33.3,0-49.3,0.1c-1.1,0-3.1,1-3.2,1.6c-1,5-1.7,10-2.5,15.1
                c-0.1,0.8-0.6,1.6-1.1,2.4c-1.2,1.8-0.2,2.7,4.2,2.6c15.1,0,30.2,0,45.3,0c3.3,0,4-0.7,4-1.9C369.6,549.5,369.7,547.8,370,546.1z"
                />
                <path
                    class="st0"
                    d="M369.2,508.2c-13.3,0-26.6,0-39.9,0c-3.6,0-5.5,0.8-5.5,2.6c0,2.1-0.2,4.2-0.6,6.3c-0.6,3.4-1.5,6.9-2.2,10.5
                c17.4,0,33.7,0,50.2,0c0.8-5.9,1.6-11.5,2.4-17.1C373.8,509.1,372.9,508.2,369.2,508.2z"
                />
                <path
                    class="st0"
                    d="M467,437.5c-12.2-0.1-24.4-0.1-37.1-0.1c0,4,0.1,7.6,0,11.2c-0.1,1.7,1.8,2.4,5.2,2.4c11,0,22,0.1,32.9-0.1
                c1.5,0,4.2-0.9,4.2-1.4c-0.2-3.5-0.7-7-1.6-10.4C470.4,438.5,468.2,437.5,467,437.5z"
                />
                <path
                    class="st0"
                    d="M566,437.5c1.7,3.9,3,7.5,4.9,11.2c0.6,1.2,2.7,1.8,6,1.8c7-0.1,14,0,21-0.1c5.1,0,10.3,0,16,0
                c-2.7-4.6-5.1-8.7-7.7-12.9C593.1,437.5,579.9,437.5,566,437.5z"
                />
                <path
                    class="st0"
                    d="M617.6,447.9c0.8,1.9,2.3,2.5,6.2,2.5c3.1,0,6.2,0,9.4,0c1.6-4.3,3.2-8.6,4.6-12.9c-8.7,0-17.5,0-26.5,0
                C613.6,441.1,616.1,444.5,617.6,447.9z"
                />
                <path
                    class="st0"
                    d="M550.9,527.6c13.3,0,26.3,0,39.3,0c2.5-3.3,4.9-6.6,7.3-10c-1.2-2.2-2.4-4.3-3-6.5c-0.7-2.3-2.8-2.8-7.2-2.8
                c-10.8,0-21.6,0-32.4,0c-3.2,0-6.4,0.2-9.6,0.3c0.3,1.3,0.6,2.6,1,3.9C547.8,517.4,549.4,522.5,550.9,527.6z"
                />
                <path
                    class="st0"
                    d="M542.6,503.7c0.3,0.7,3.5,1.6,5.4,1.6c8.4,0.2,16.9,0.1,25.3,0.1c6.1,0,12.1,0,18.5,0
                c-1.8-4.1-3.4-7.8-5.1-11.6c-0.4-0.9-1.1-1.7-1.2-2.5c-0.1-2.1-1.9-3.1-6.8-3c-10.6,0.1-21.2,0-31.8,0c-3,0-5.9,0-9.1,0
                c0,0.8-0.1,1.2,0,1.6C539.4,494.5,540.7,499.1,542.6,503.7z"
                />
                <path
                    class="st0"
                    d="M535,467c10.4-0.1,20.9,0,31.3,0c2.6,0,5.2-0.1,7.9-0.2c-2.2-4.7-4.3-9.2-6.4-13.6c-14.1,0-27.9,0-41.7,0
                c1.1,3.9,2.3,7.6,3,11.2C529.5,466.3,530.8,467.1,535,467z"
                />
                <path
                    class="st0"
                    d="M587.3,483.1c0.7,1.9,2,2.5,6,2.4c7.9-0.1,15.9,0,23.8,0c2.7-5,5.2-10.1,7.6-15.3c-0.7-0.3-1.5-0.5-2.1-0.5
                c-13.6-0.1-27.3-0.1-41.6-0.1c0.2,0.8,0.1,1.2,0.3,1.6C583.5,475.2,586,479.1,587.3,483.1z"
                />
                <path
                    class="st0"
                    d="M623.1,410.1c-7.2,0.1-14.4,0.1-21.6,0c-4.8-0.1-6.2,1-5.3,2.9c1.3,2.6,2.9,5.2,4.6,7.8
                c0.3,0.4,2.1,0.9,3.3,0.9c11.7,0.1,23.3,0,35.1,0c0.1-0.6,0.4-1,0.2-1.4c-1.7-2.4-3.9-4.8-5.2-7.2
                C632.7,410.3,628.4,410.1,623.1,410.1z"
                />
                <path
                    class="st0"
                    d="M601.5,505.3c1.4,0,2.7,0,4.1,0c3.5-5.6,6.9-11.3,10.1-17.1c-6.1,0-12.2,0-18.2,0c-2.4,0-4.9,0.1-7.2,0.2
                c2.1,4.9,4,9.6,6.2,14.3C597,503.8,597.5,505.4,601.5,505.3z"
                />
                <path
                    class="st0"
                    d="M478.4,453.2c0.9,4.7,1.7,9.2,2.5,13.6c15.7,0,29.8,0,44.1,0c-1.7-4.7-3.2-9.2-4.8-13.6
                C506.1,453.2,492.2,453.2,478.4,453.2z"
                />
                <path
                    class="st0"
                    d="M565.1,556.3c-1.2,0-3.4,1-3.3,1.5c0.1,0.6,0.2,1.1,0.4,1.7c1.1-1.1,2.1-2.1,3.2-3.2
                C565.3,556.3,565.2,556.3,565.1,556.3z"
                />
                <path
                    class="st0"
                    d="M574.5,453.1c0,0.5-0.2,0.8-0.1,1.1c1.5,3.4,3.5,6.8,4.2,10.3c0.4,2.1,2.1,2.6,6.2,2.5c8.3-0.1,16.5,0,24.8,0
                c4.4,0,8.8,0,14,0c-2.9-4.9-5.6-9.4-8.2-13.9C601.5,453.1,588.1,453.1,574.5,453.1z"
                />
                <path
                    class="st0"
                    d="M566.8,450.9c-1.4-3.5-2.4-6.1-3.5-8.6c-0.4-0.9-1.5-1.7-1.3-2.5c0.3-2-1.8-2.5-5.8-2.4
                c-5.7,0.1-11.5,0-17.2,0c-6,0-12.1,0-18.4,0c1,3.5,1.3,6.7,3,9.7c0.9,1.5,0.2,4.1,7,4C542.1,450.8,553.8,450.9,566.8,450.9z"
                />
                <path class="st0" d="M627.5,464.1c1.6-3.7,3.2-7.4,4.6-11.2c-3.6,0-7.3,0-11.1,0C623.3,456.9,625.4,460.5,627.5,464.1z" />
                <path class="st0" d="M600.8,512c0.1,0.1,0.1,0.3,0.2,0.4c0.9-1.4,1.8-2.7,2.7-4.1C600.1,508.7,599.5,509.7,600.8,512z" />
                <path
                    class="st0"
                    d="M536,484.2c0.2,0.6,3,1.3,4.6,1.3c7.7,0.1,15.5,0.1,23.2,0.1c6.2,0,12.5,0,19.1,0c-0.7-1-1.4-1.7-1.6-2.4
                c-1.6-3.9-2.9-7.9-4.7-11.8c-0.3-0.6-2.4-1.6-3.8-1.6c-13.6-0.1-27.3-0.1-41.2-0.1c-0.1,0.7-0.2,0.9-0.2,1.2
                C532.9,475.3,534.2,479.8,536,484.2z"
                />
                <path
                    class="st0"
                    d="M442,556.3c-1.2,0-3.5,1-3.5,1.5c0,7.6,0.4,15.1,0.7,22.8c20.1,0,38.7,0,58.3,0c-0.9-3.2-1.9-6.1-2.6-9.1
                c-0.9-4.5-1.5-9.1-2.5-13.6c-0.1-0.6-2.2-1.5-3.4-1.5C473.4,556.2,457.7,556.2,442,556.3z"
                />
                <path
                    class="st0"
                    d="M492.9,526c0.1,0.6,2.6,1.6,4,1.6c15.6,0.1,31.3,0.1,48.1,0.1c-1-2.3-2-4.1-2.6-6c-1-3.3-1.2-6.6-2.7-9.8
                c-0.7-1.4,0.1-3.8-6.2-3.7c-12.8,0.1-25.6,0.1-38.3,0c-3.8,0-5.1,0.6-4.8,2.3C491.1,515.7,491.7,520.9,492.9,526z"
                />
                <path
                    class="st0"
                    d="M488,502.8c0.1,2.4,2.6,3.1,7.3,3.1c9.9,0,19.8,0.1,29.7-0.1c4.1-0.1,8.3-0.5,12.3-0.8
                c-1.9-5.8-3.7-11.3-5.5-16.7c-15.8,0-30.5,0-45.7,0c0,0.9-0.1,1.7,0,2.5C486.6,494.9,487.8,498.8,488,502.8z"
                />
                <path
                    class="st0"
                    d="M503.2,553.1c7.5,0.1,15.1,0.1,22.6,0c7.7,0,15.5,0.1,23.2-0.1c1.3,0,3.6-0.9,3.6-1.4
                c-0.3-2.3-1.3-4.6-2.1-6.9c-1.3-3.6-3.1-7.3-3.7-10.9c-0.4-2.3-2.6-3-7-3c-13.1,0-26.2,0-39.4,0c-4.3,0-6.4,0.6-5.9,2.7
                c1.5,6.1,2.8,12.2,4.5,18.3C499.2,552.4,501.7,553,503.2,553.1z"
                />
                <path
                    class="st0"
                    d="M637.8,412.4c1.4,1.7,1.8,3.7,4,5c0.9,0.5,1.1,1.3,1.3,2.1c0.8-3.1,1.6-6.2,2.3-9.4c-1.5,0-2.9,0-4.4,0
                C637.7,410.2,636.6,411,637.8,412.4z"
                />
                <path
                    class="st0"
                    d="M557.2,545.3c0.9,2.5,1.7,5.1,2.6,7.7c2.9,0,5.8,0,8.7,0c6.7-7.1,13-14.4,19.1-22.1c-10.3,0-20.5,0-30.8,0.1
                c-1.3,0-3.4,1.1-3.7,1.7c-0.5,1.1,0.1,2.3,0.5,3.4C554.7,539.2,556.1,542.2,557.2,545.3z"
                />
                <path
                    class="st0"
                    d="M489.8,485.6c12-0.1,24.1,0,36.1,0c1.7,0,3.4-0.1,4.8-0.2c-1.2-4.3-2.4-8.3-3.4-12.4c-0.4-1.5-0.3-3.2-4.6-3.2
                c-13.4-0.1-26.8,0-40.9,0c0.8,4.7,1.8,9,2.2,13.2C484,484.9,485.3,485.6,489.8,485.6z"
                />
                <path
                    class="st0"
                    d="M500.9,561.5c0.9,5.6,1.8,11.2,2.5,16.8c0.2,1.7,1.7,2.5,5.6,2.4c9.9-0.1,19.7,0,29.6,0
                c6.3-5.1,12.4-10.5,18.3-16.1c-0.6-1.8-1.2-3.6-1.7-5.5c-0.6-2-2.3-3-7.2-3c-13.3,0.1-26.6,0-40,0c-9,0-9,0-7.4,4.1
                C500.9,560.7,500.8,561.1,500.9,561.5z"
                />
                <path
                    class="st0"
                    d="M559.5,423.7c1.6,3.7,3,7.3,4.7,10.9c0.2,0.4,1.8,0.8,2.8,0.9c12.6,0.1,25.1,0,38.2,0c-2.6-4.2-5-8-7.3-11.8
                C584.9,423.7,572.4,423.7,559.5,423.7z"
                />
                <path
                    class="st0"
                    d="M439,505.8c12.9,0.1,25.9,0.1,38.9,0c1.4,0,3.9-1.3,3.9-1.9c-0.5-5.2-1.4-10.3-2.3-15.5c-15.4,0-30.3,0-45.4,0
                c0,5.4-0.2,10.6,0.2,15.8C434.4,504.8,437.4,505.8,439,505.8z"
                />
                <path
                    class="st0"
                    d="M636,423.5c-7.3,0.2-14.7,0.1-22.1,0.1c-3.6,0-7.3,0-11,0c2.5,4.2,4.7,7.9,7,11.8c9.4,0,19,0,28.6,0
                c1.2-3.6,2.3-7.3,3.3-10.9C640.6,423.8,638.9,423.4,636,423.5z"
                />
                <path
                    class="st0"
                    d="M515.9,423.7c1,3.6,1.8,7,3,10.4c0.2,0.5,2.5,1.3,3.8,1.3c12.2,0.1,24.3,0.1,37.1,0.1
                c-1.9-4.1-3.6-7.9-5.4-11.8C542,423.7,529.5,423.7,515.9,423.7z"
                />
                <path
                    class="st0"
                    d="M437.2,485.5c10.4,0,20.9,0,31.3,0c3.5,0,7,0,10.3,0c-1-5.5-2-10.6-2.9-15.7c-15.3,0-29.3,0-43.7,0
                c0,4.9,0,9.4,0,14C432.2,485.4,434.5,485.5,437.2,485.5z"
                />
                <path
                    class="st0"
                    d="M512.9,437.4c-12.4-0.1-24.7-0.1-38.1-0.1c0.9,4.3,1.6,8.3,2.7,12.2c0.2,0.5,2.7,1.3,4.2,1.3
                c10.8,0.1,21.6,0,32.4,0.1c3.5,0,4.9-0.6,4.5-2.2c-0.9-3.4-1.5-6.7-2.5-10.1C515.9,438.2,514,437.5,512.9,437.4z"
                />
            </g>
            <g id="outer-ring">
                <path
                    class="st1"
                    d="M341,678.5c-89.6,0-173.8-34.9-237.2-98.3S5.4,432.5,5.4,343s34.9-173.9,98.3-237.2S251.3,7.4,341,7.4
                s173.9,34.9,237.2,98.3s98.3,147.6,98.3,237.2s-34.9,173.9-98.3,237.2S430.6,678.5,341,678.5L341,678.5z M341,36.1
                c-169.2,0-306.8,137.7-306.8,306.8S171.9,649.7,341,649.7S647.8,512,647.8,342.9S510.1,36.1,341,36.1z"
                />
            </g>
            <circle id="bg-circ-outer" class="circ st2" cx="335.6" cy="351.8" r="239.4" />
            <circle id="bg-circ-inner" class="circ st3" cx="334.5" cy="352.7" r="217.8" />
            <g class="big-eye" id="big-eye_00000097459649484819074050000010293150555879428796_">
                <path class="st4" d="M289.7,353.5c0,0,14.9-25.5,42.8-25.5s45.3,24,45.3,24s-16.2,25-44.1,25.2S289.7,353.5,289.7,353.5z" />
                <g id="eye-color">
                    <circle id="iris" class="st5" cx="334.3" cy="352.7" r="19.3" />
                    <circle id="pupil" class="st6" cx="334.3" cy="352.7" r="13.2" />
                </g>
            </g>
            <g class="space-wheel">
                <g>
                    <g id="wheel-outer_00000029763621332474673970000016296382660854014380_">
                        <g id="wheel-outer_00000109730628506925075480000011443312265628597423_">
                            <path
                                class="st7"
                                d="M352.6,447.5c2.6,0.1,5.6,0.5,7.1,2.7c1.4,2.1,0.8,5.1-0.7,7c-1.6,2-3.9,3.2-6.2,4.3
                            c-20.2,10.2-41,19.1-62.3,26.7c-14.3,5.1-29.7,9.7-44.6,6.5c-3.4-0.7-7.2-2.4-7.9-5.8c-0.8-4.1,3.5-7.2,7.1-9.1
                            c14.8-8,29.6-16,44.4-24c5.2-2.8,10.4-5.6,16.1-7.1c8-2.1,13.4,1.8,20.8,1.9C335.1,450.7,343.7,447.2,352.6,447.5z"
                            />
                            <path
                                class="st7"
                                d="M454.6,243.3c2.9-0.8,6,1.9,6.3,4.9s-1.6,5.9-4.1,7.7c-2.5,1.7-5.5,2.6-8.4,3.4
                            c-13.2,3.6-26.2,7.6-39.2,11.9c-11.6,3.9-23.1,8-34.6,12.1c-8.3,3-16.5,5.9-24.8,8.9c-11,4-22,7.9-33,11.9
                            c-12.8,4.6-20.8,16.8-34.2,18.9c-2.9,0.5-6.3,0.6-8.4-1.5c-2.2-2.1-2.1-5.7-0.7-8.4c1.4-2.7,3.9-4.5,6.4-6.3
                            c36.9-26.7,77.8-47.4,118.6-68c7.8-3.9,15.9-7.9,24.6-8C433.9,230.7,445.5,237.4,454.6,243.3z"
                            />
                            <path
                                class="st7"
                                d="M448.7,408.4c6.4-5.6,12.8-11.1,19.3-16.7c2.1-1.8,4.3-3.9,4.9-6.6c0.9-4.6-3.7-8.7-8.3-9.2
                            s-9.1,1.7-13.2,4c-22.7,12.3-43.7,27.8-62.2,45.9c-3,2.9-6.1,7.1-4.4,10.9c2,4.2,8.1,3.9,12.5,2.4c12-4.1,22.7-12.1,30-22.4"
                            />
                            <path
                                class="st7"
                                d="M514.3,266.1c0,0-12.4,60.3-119.7,119.2S235,452.4,235,452.4s-5.9,6.6-76.8-0.4c0,0-1.7,29.1,16.5,38.1
                            c0,0,24.1,15.2,68.4,3.8c44.3-11.4,121.4-38.8,162.3-64.2c41-25.4,93.6-65.7,118.1-104C548,287.4,527,270.5,514.3,266.1z"
                            />
                            <path
                                class="st8"
                                d="M153.7,421.1c-2.9,3.7-4,5.7-6.8,11.3c-8,16.3-14,41.9-0.2,58.6c28.9,34.9,117.1,8.4,158.1-6.8
                            c32.1-12.3,64.5-29.1,95.1-43.8c11.8-6,24.1-11.2,35.1-17.9c7-4.9,11.4-8.5,20.6-15.8c44-35.7,158.5-133.6,61.1-156.3
                            c-60.1-11.2-142.5,21.7-194.7,45.7l-0.1,0.1c-25.4,11-56.5,29-80.4,46.1C192.9,377,165.2,407.8,153.7,421.1z M251.7,347
                            c21.8-15.7,50.1-32.1,73.1-42.2l0.1-0.1c47.4-22,122.2-52.3,176.7-42.4c88.1,20-16.2,109.3-56.2,141.9
                            c-8.3,6.6-12.4,10-18.7,14.4c-10,6.1-21.2,10.9-31.9,16.4c-27.8,13.4-57.3,28.9-86.5,40.2c-37.2,14-117.3,38.4-143.3,7
                            c-12.5-15.1-6.9-38.3,0.5-53.1c2.5-5.1,3.5-6.9,6.2-10.3C182.1,406.7,207.4,378.6,251.7,347z"
                            />
                            <g id="spokes_00000148660404409061419310000016223702116738838956_">
                                <path
                                    class="st7"
                                    d="M362.9,233.2c118.9-47.8,167.3-4.3,167.3-4.3l23.5,41.5c-7.4-12-38.8-23.3-87.5-19.8
                                c-52.2,3.7-124.3,24.4-207.8,79.4c-119.2,78.4-125.7,130-120.9,151.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.7-0.8-1.4-1.5-2.2-2.2
                                L113,436.9C128.2,343.2,244,281.1,362.9,233.2z"
                                />
                                <g>
                                    <polygon class="st8" points="529.7,256.2 531.9,255 512,217.9 509.8,219 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="506.6,251.6 508.7,250.5 489.4,212.7 487.3,213.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="481.5,250.5 483.7,249.3 463.6,211.2 461.5,212.3 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="418.9,261.9 421.1,260.8 401,222.6 398.9,223.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="384,272.4 386.2,271.3 366.1,233.1 364,234.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="346.1,286.9 348.3,285.8 328.2,247.6 326.1,248.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="310,304.1 312.1,303 292.1,264.8 290,265.9 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="274.5,322.9 276.7,321.7 256.6,283.6 254.5,284.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="240.2,343.9 242.4,342.8 222.3,304.6 220.2,305.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="210.7,365.4 212.8,364.3 192.8,326.1 190.7,327.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="184,390 186.1,388.9 166.1,350.7 163.9,351.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="163.8,414.2 165.9,413.1 145.9,374.9 143.7,376 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="148.3,435.7 150.4,434.6 130.4,396.4 128.3,397.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="138.4,456.7 140.6,455.6 120.5,417.4 118.4,418.6 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="531.2,308.7 533.3,307.6 514.2,272.3 512.1,273.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="522.1,325.8 524.3,324.7 505.1,289.4 503,290.6 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="508,345.9 510.2,344.8 491,309.5 488.9,310.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="488.4,365.5 490.5,364.3 471.4,329.1 469.2,330.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="465.8,386.8 467.9,385.6 448.8,350.4 446.7,351.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="438.4,406.1 440.6,404.9 421.4,369.7 419.3,370.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="408.1,426.7 410.2,425.5 391.1,390.3 388.9,391.4 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="375.2,445.6 377.3,444.5 358.2,409.2 356,410.4 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="341.5,461.1 343.6,459.9 324.5,424.7 322.4,425.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="309.5,472.4 311.6,471.2 292.5,436 290.3,437.1 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="277.6,484.4 279.7,483.3 260.6,448 258.4,449.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="246.6,492.3 248.8,491.1 229.6,455.9 227.5,457 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="220.7,497.9 222.8,496.8 203.7,461.5 201.5,462.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="196.7,497.4 198.9,496.2 179.7,461 177.6,462.1 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="178.9,493.9 181,492.8 161.9,457.5 159.8,458.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="451,253.8 453.1,252.7 433.1,214.5 430.9,215.6 						" />
                                </g>
                            </g>
                        </g>
                        <g id="wheel-eyes_00000157273532286735313400000014870449524693464195_">
                            <g id="big-eye_00000021820735106117629620000015166178991302178964_">
                                <path
                                    class="st9"
                                    d="M361.7,271.7c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C352.1,270.6,361.7,271.7,361.7,271.7z"
                                />
                                <ellipse class="st5" cx="354.9" cy="258.4" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="354.9" cy="258.4" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000037656482507951833440000017080841579787475390_">
                                <path
                                    class="st9"
                                    d="M324.6,288c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C315,287,324.6,288,324.6,288z"
                                />
                                <ellipse class="st5" cx="317.9" cy="274.8" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="317.9" cy="274.8" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000067918883193819555100000014160338295888353668_">
                                <path
                                    class="st9"
                                    d="M288.5,305.8c0,0,5.2-8.4,0.8-16.6s-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C278.9,304.7,288.5,305.8,288.5,305.8z"
                                />
                                <ellipse class="st5" cx="281.8" cy="292.5" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="281.8" cy="292.5" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000047743854979144359830000011615577159105086362_">
                                <path class="st9" d="M253.4,326.6c0,0,5.3-8.3,1-16.6s-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9S253.4,326.6,253.4,326.6z" />
                                <ellipse class="st5" cx="246.8" cy="313.3" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="246.8" cy="313.3" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000078767308197284090390000007806014114125653175_">
                                <path class="st9" d="M222.5,349c0,0,5.3-8.3,1-16.6s-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9S222.5,349,222.5,349z" />
                                <ellipse class="st5" cx="215.9" cy="335.7" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="215.9" cy="335.7" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000094606939066295264480000005930508533228707205_">
                                <path
                                    class="st10"
                                    d="M194.1,372.4c0,0,4.5-7.9,0.2-16.2S181,346.1,181,346.1s-4.2,8.2,0.1,16.5
                                C185.3,370.8,194.1,372.4,194.1,372.4z"
                                />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -148.1252 132.2404)" class="st5" cx="187.5" cy="359.1" rx="5.8" ry="6.4" />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -148.1252 132.2404)" class="st6" cx="187.5" cy="359.1" rx="3.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000169548991626206234810000003602645163091271356_">
                                <path
                                    class="st11"
                                    d="M169.3,393.7c0,0,3.6-7.4-0.7-15.7c-4.3-8.3-12.5-10.6-12.5-10.6s-3.3,7.8,0.9,16.1
                                C161.3,391.8,169.3,393.7,169.3,393.7z"
                                />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -158.4625 119.558)" class="st5" cx="162.7" cy="380.4" rx="5" ry="6.4" />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -158.4625 119.558)" class="st6" cx="162.7" cy="380.4" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000086656708263198951830000012269649248599962498_">
                                <path
                                    class="st12"
                                    d="M150.2,415.8c0,0,2.7-6.9-1.6-15.2c-4.3-8.3-11.6-11-11.6-11s-2.4,7.3,1.9,15.6
                                C143.1,413.4,150.2,415.8,150.2,415.8z"
                                />

                                <ellipse transform="matrix(0.8866 -0.4625 0.4625 0.8866 -169.885 112.007)" class="st5" cx="143.5" cy="402.5" rx="4.2" ry="6.4" />

                                <ellipse transform="matrix(0.8866 -0.4625 0.4625 0.8866 -169.885 112.007)" class="st6" cx="143.5" cy="402.5" rx="2.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000083768191691854649220000016045090004375706518_">
                                <path
                                    class="st13"
                                    d="M138.3,436.3c0,0,0.9-6-3.4-14.3c-4.3-8.3-10-11.9-10-11.9s-0.7,6.4,3.6,14.7
                                C132.9,433,138.3,436.3,138.3,436.3z"
                                />

                                <ellipse transform="matrix(0.8877 -0.4604 0.4604 0.8877 -179.9963 108.101)" class="st5" cx="131.6" cy="423" rx="2.7" ry="6.4" />

                                <ellipse transform="matrix(0.8877 -0.4604 0.4604 0.8877 -179.9963 108.101)" class="st6" cx="131.6" cy="423" rx="1.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000008144710467210100300000012596553020222529971_">
                                <path
                                    class="st14"
                                    d="M131.3,456.1c0,0,0.2-5.7-4.1-14c-4.3-8.3-9.3-12.2-9.3-12.2s0,6.1,4.3,14.3
                                C126.5,452.5,131.3,456.1,131.3,456.1z"
                                />

                                <ellipse transform="matrix(0.8879 -0.46 0.46 0.8879 -189.7461 106.9319)" class="st5" cx="124.5" cy="442.8" rx="2.1" ry="6.4" />

                                <ellipse transform="matrix(0.8879 -0.46 0.46 0.8879 -189.7461 106.9319)" class="st6" cx="124.5" cy="442.8" rx="1.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000078759326185356497650000015106137025098305695_">
                                <path
                                    class="st15"
                                    d="M432.2,249.3c0,0,4.3-7.8,0-16.1S419,222.9,419,222.9s-4,8.1,0.3,16.4
                                C423.6,247.6,432.2,249.3,432.2,249.3z"
                                />

                                <ellipse transform="matrix(0.8818 -0.4715 0.4715 0.8818 -60.9796 228.5484)" class="st5" cx="425.6" cy="236" rx="5.6" ry="6.4" />

                                <ellipse transform="matrix(0.8818 -0.4715 0.4715 0.8818 -60.9796 228.5484)" class="st6" cx="425.6" cy="236" rx="3.8" ry="4.4" />
                            </g>
                            <g id="big-eye_00000144318319513587667450000009985446829761060250_">
                                <path
                                    class="st9"
                                    d="M398.1,259.7c0,0,5.3-8.3,1-16.6c-4.3-8.3-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9
                                C388.5,258.5,398.1,259.7,398.1,259.7z"
                                />
                                <ellipse class="st5" cx="391.5" cy="246.3" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="391.5" cy="246.3" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000040539961014317030570000012957511748309629873_">
                                <path
                                    class="st16"
                                    d="M463.5,244.2c0,0,3.6-7.4-0.6-15.7s-12.5-10.6-12.5-10.6s-3.3,7.8,0.9,16.1
                                C455.5,242.3,463.5,244.2,463.5,244.2z"
                                />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -54.9633 239.415)" class="st5" cx="456.9" cy="230.9" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -54.9633 239.415)" class="st6" cx="456.9" cy="230.9" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000086660800658945417340000011424899700289572225_">
                                <path class="st17" d="M491,242c0,0,2.8-7-1.5-15.3c-4.3-8.3-11.7-11-11.7-11s-2.5,7.4,1.7,15.6C483.7,239.6,491,242,491,242z" />

                                <ellipse transform="matrix(0.8864 -0.4628 0.4628 0.8864 -50.8336 250.1219)" class="st5" cx="484.3" cy="228.7" rx="4.3" ry="6.4" />

                                <ellipse transform="matrix(0.8864 -0.4628 0.4628 0.8864 -50.8336 250.1219)" class="st6" cx="484.3" cy="228.7" rx="3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000086682612455179139150000013262354313603573376_">
                                <path
                                    class="st18"
                                    d="M514.3,244.5c0,0,1.3-6.3-3-14.6c-4.3-8.3-10.4-11.7-10.4-11.7s-1.1,6.6,3.2,14.9
                                S514.3,244.5,514.3,244.5z"
                                />

                                <ellipse transform="matrix(0.8875 -0.4607 0.4607 0.8875 -49.4353 259.8502)" class="st5" cx="507.6" cy="231.2" rx="3.1" ry="6.4" />

                                <ellipse transform="matrix(0.8875 -0.4607 0.4607 0.8875 -49.4353 259.8502)" class="st6" cx="507.6" cy="231.2" rx="2.1" ry="4.4" />
                            </g>
                            <g id="big-eye_00000052805292109005068080000004252984526834539908_">
                                <path
                                    class="st19"
                                    d="M535.1,251.9c0,0,0-5.6-4.3-13.9c-4.3-8.3-9.1-12.3-9.1-12.3s0.3,5.9,4.5,14.2
                                C530.5,248.2,535.1,251.9,535.1,251.9z"
                                />

                                <ellipse transform="matrix(0.8879 -0.4599 0.4599 0.8879 -50.5479 269.7663)" class="st5" cx="528.4" cy="238.6" rx="1.9" ry="6.4" />

                                <ellipse transform="matrix(0.8879 -0.4599 0.4599 0.8879 -50.5479 269.7663)" class="st6" cx="528.4" cy="238.6" rx="1.3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000083071746031781479420000015319587190389715362_">
                                <path
                                    class="st9"
                                    d="M388.6,430.2c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C379,429.1,388.6,430.2,388.6,430.2z"
                                />
                                <ellipse class="st5" cx="381.8" cy="416.9" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="381.8" cy="416.9" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000033326691229053588770000011137202658431868076_">
                                <path
                                    class="st9"
                                    d="M356.6,447.3c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C347,446.3,356.6,447.3,356.6,447.3z"
                                />
                                <ellipse class="st5" cx="349.8" cy="434.1" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="349.8" cy="434.1" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000133495793408711707770000018153391432092166809_">
                                <path
                                    class="st9"
                                    d="M323.5,462c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C313.9,461,323.5,462,323.5,462z"
                                />
                                <ellipse class="st5" cx="316.8" cy="448.8" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="316.8" cy="448.8" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000130609575428540900980000009413914635353136010_">
                                <path
                                    class="st9"
                                    d="M292.9,473.8c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C283.3,472.7,292.9,473.8,292.9,473.8z"
                                />
                                <ellipse class="st5" cx="286.1" cy="460.5" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="286.1" cy="460.5" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000013164696662876977690000005774967389764338617_">
                                <path
                                    class="st9"
                                    d="M423.3,411.9c0,0,5.2-8.4,0.8-16.6s-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C413.7,410.8,423.3,411.9,423.3,411.9z"
                                />
                                <ellipse class="st5" cx="416.6" cy="398.6" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="416.6" cy="398.6" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000044147604770558838730000001025525499446109827_">
                                <path
                                    class="st20"
                                    d="M450.9,391.5c0,0,3.7-7.5-0.7-15.8c-4.4-8.2-12.8-10.4-12.8-10.4s-3.3,7.9,1,16.1
                                C442.7,389.7,450.9,391.5,450.9,391.5z"
                                />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -126.7256 257.9494)" class="st5" cx="444.1" cy="378.3" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -126.7256 257.9494)" class="st6" cx="444.1" cy="378.3" rx="3.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000047756413751634244220000004769597597189117114_">
                                <path
                                    class="st20"
                                    d="M475.3,371.1c0,0,3.7-7.5-0.7-15.8c-4.4-8.2-12.8-10.4-12.8-10.4s-3.3,7.9,1,16.1
                                C467.2,369.3,475.3,371.1,475.3,371.1z"
                                />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -114.0105 267.1443)" class="st5" cx="468.5" cy="357.9" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -114.0105 267.1443)" class="st6" cx="468.5" cy="357.9" rx="3.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000092434250967322016150000016033572761038952881_">
                                <path
                                    class="st21"
                                    d="M495.3,351.2c0,0,3.2-7.3-1.2-15.5s-12.3-10.6-12.3-10.6s-2.9,7.6,1.5,15.9
                                C487.6,349.2,495.3,351.2,495.3,351.2z"
                                />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -101.9452 272.7003)" class="st5" cx="488.4" cy="338" rx="4.7" ry="6.4" />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -101.9452 272.7003)" class="st6" cx="488.4" cy="338" rx="3.2" ry="4.4" />
                            </g>
                            <g id="big-eye_00000177467905293754712970000006833492679056724124_">
                                <path
                                    class="st22"
                                    d="M513.3,331.4c0,0,1.9-6.6-2.5-14.8c-4.4-8.2-11.1-11.3-11.1-11.3s-1.6,6.9,2.8,15.2
                                S513.3,331.4,513.3,331.4z"
                                />

                                <ellipse transform="matrix(0.8814 -0.4724 0.4724 0.8814 -90.2383 276.9353)" class="st5" cx="506.4" cy="318.2" rx="3.6" ry="6.4" />

                                <ellipse transform="matrix(0.8814 -0.4724 0.4724 0.8814 -90.2383 276.9353)" class="st6" cx="506.4" cy="318.2" rx="2.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000061469052904457390160000004146528306139031727_">
                                <path
                                    class="st23"
                                    d="M526.8,313.6c0,0,0.8-6-3.6-14.3c-4.4-8.2-10.1-11.8-10.1-11.8s-0.5,6.4,3.8,14.6
                                C521.3,310.4,526.8,313.6,526.8,313.6z"
                                />

                                <ellipse transform="matrix(0.8819 -0.4714 0.4714 0.8819 -80.2285 280.537)" class="st5" cx="519.9" cy="300.4" rx="2.7" ry="6.4" />

                                <ellipse transform="matrix(0.8819 -0.4714 0.4714 0.8819 -80.2285 280.537)" class="st6" cx="519.9" cy="300.4" rx="1.8" ry="4.4" />
                            </g>
                            <g id="big-eye_00000033341899834614041250000005039676421803776642_">
                                <path
                                    class="st24"
                                    d="M532.1,295.9c0,0,0-5.6-4.4-13.8s-9.3-12.2-9.3-12.2s0.3,6,4.6,14.2C527.4,292.2,532.1,295.9,532.1,295.9
                                z"
                                />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -71.2501 280.6657)" class="st5" cx="525.2" cy="282.7" rx="2" ry="6.4" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -71.2501 280.6657)" class="st6" cx="525.2" cy="282.7" rx="1.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000021102749659719989960000005620297412607279803_">
                                <path
                                    class="st25"
                                    d="M259.2,483.4c0,0,3.5-7.5-0.9-15.7c-4.4-8.2-12.6-10.4-12.6-10.4s-3.2,7.8,1.1,16
                                C251.2,481.5,259.2,483.4,259.2,483.4z"
                                />

                                <ellipse transform="matrix(0.8791 -0.4766 0.4766 0.8791 -193.5661 177.1104)" class="st5" cx="252.4" cy="470.1" rx="5" ry="6.4" />

                                <ellipse transform="matrix(0.8791 -0.4766 0.4766 0.8791 -193.5661 177.1104)" class="st6" cx="252.4" cy="470.1" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000158014964698560353140000004657907736039539596_">
                                <path
                                    class="st26"
                                    d="M231.1,487.9c0,0,2.7-7-1.7-15.3c-4.4-8.2-11.8-10.9-11.8-10.9s-2.4,7.4,2,15.6
                                C223.9,485.6,231.1,487.9,231.1,487.9z"
                                />

                                <ellipse transform="matrix(0.8807 -0.4737 0.4737 0.8807 -198.0951 162.8742)" class="st5" cx="224.3" cy="474.7" rx="4.3" ry="6.4" />

                                <ellipse transform="matrix(0.8807 -0.4737 0.4737 0.8807 -198.0951 162.8742)" class="st6" cx="224.3" cy="474.7" rx="2.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000049926513894984806750000015560682202847480474_">
                                <path
                                    class="st27"
                                    d="M205.7,489.5c0,0,1.6-6.5-2.8-14.7c-4.4-8.2-10.9-11.4-10.9-11.4s-1.4,6.8,3,15.1
                                C199.4,486.7,205.7,489.5,205.7,489.5z"
                                />

                                <ellipse transform="matrix(0.8815 -0.4721 0.4721 0.8815 -201.3152 150.2825)" class="st5" cx="198.8" cy="476.3" rx="3.4" ry="6.4" />

                                <ellipse transform="matrix(0.8815 -0.4721 0.4721 0.8815 -201.3152 150.2825)" class="st6" cx="198.8" cy="476.3" rx="2.3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000045606289786647651140000006541264515919327130_">
                                <path class="st28" d="M184.7,487.6c0,0,0.1-5.6-4.3-13.9s-9.4-12.2-9.4-12.2s0.2,6,4.6,14.2C180,484,184.7,487.6,184.7,487.6z" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -202.5082 139.6768)" class="st5" cx="177.8" cy="474.5" rx="2.1" ry="6.4" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -202.5082 139.6768)" class="st6" cx="177.8" cy="474.5" rx="1.4" ry="4.4" />
                            </g>
                        </g>
                    </g>
                </g>
                <g class="space-wheel" id="wheel-outer_00000098910195497304160380000014163205768833563556_">
                    <g id="wheel-outer_00000042735716887946906210000017756716277317392784_">
                        <path
                            class="st7"
                            d="M249.4,409.1c-2.1-2-4.7-4.1-7.6-3.6c-2.8,0.4-4.7,3.2-5.1,6c-0.4,2.8,0.4,5.6,1.2,8.2
                        c7.2,23.9,16,47.3,26.1,70c6.8,15.3,14.9,31.1,28.8,40.5c3.2,2.1,7.5,3.9,10.7,1.8c3.8-2.5,3.1-8.2,1.9-12.7
                        c-4.9-17.9-9.7-35.8-14.6-53.7c-1.7-6.2-3.4-12.6-6.6-18.2c-4.5-8-11.6-9.2-17.3-15.1C260.3,425.5,256.5,416,249.4,409.1z"
                        />
                        <path
                            class="st7"
                            d="M335.1,171.4c-1.6-3-6.1-3.4-8.7-1.3c-2.6,2.1-3.5,5.8-3,9.2c0.5,3.3,2.1,6.4,3.7,9.3
                        c7.1,13.3,13.9,26.7,20.3,40.3c5.7,12.2,11.2,24.5,16.7,36.8c3.9,8.9,7.9,17.7,11.8,26.6c5.2,11.8,10.4,23.6,15.7,35.4
                        c1,2.2,1.7,4.5,2.3,6.8c2,8.2,1.9,16.7,4.1,24.9c1,3.5,6.5,18.1,12.3,15.1c3.3-1.7,1.8-8.6,0.2-10.9c-1.4-2-3.5-2.8-5.9-1.6
                        c-4,2-3.7,7.3-3.2,10.9c2.1,17,5.8,33.7,11,50c0.5,1.5,1,3,2,4.1c1.9,2,5.2,2.2,7.7,1c2.5-1.2,4.3-3.5,5.7-5.8
                        c5-8.7,5.3-19.4,3-29.2c-1.6-6.6-4.2-12.8-7.2-18.8c-2.6-5.3-5.1-9.1-5.9-14.9c-6.8-49.9-21.4-98.3-36-146.5
                        c-2.8-9.2-5.7-18.7-12.3-25.7C361,178.2,346.8,174.2,335.1,171.4z"
                        />
                        <path
                            class="st7"
                            d="M271.4,141.4c0,0-38.8,56.1-4.2,186.6s68,178.5,68,178.5s-0.8,9.8,58.9,60.9c0,0-22,23.7-43.1,16.1
                        c0,0-30.5-7.5-55.1-51.5c-24.6-44-61.5-126.4-72.4-178.5s-18.7-124.9-6.8-173.8C228.6,130.8,258.2,134.6,271.4,141.4z"
                        />
                        <path
                            class="st8"
                            d="M418.2,417c-4.5-32.2-13.9-70.7-24.4-99.4l-0.1-0.1c-20.5-59.9-57-150.8-111.8-190
                        c-92.4-60.2-83.4,106.1-78.5,168.5c1.2,12.8,1.6,19.2,3,28.5c3.1,13.9,8.3,27.7,12.5,41.7c11.6,35.6,22.9,74.3,37.5,109.3
                        c19.1,44.3,65.1,134.8,115.1,131.1c24-1.8,39.9-26.2,46.8-45.1c2.4-6.5,3.2-8.9,3.9-14.1C424.1,528,427.6,482.3,418.2,417z
                        M410.5,531.2c-0.7,4.7-1.3,6.9-3.5,12.8c-6.2,17.2-20.6,39.4-42.2,41.1c-45,3.4-86.5-79.1-103.7-119.5
                        c-13.2-31.9-23.3-67.2-33.8-99.6c-3.7-12.7-8.5-25.3-11.2-38c-1.3-8.5-1.7-14.3-2.7-26c-4.5-56.9-12.5-208.4,70.7-153.5
                        c49.4,35.8,82.2,118.6,100.7,173.2l0,0.1c9.5,26.2,17.9,61.2,22,90.6C415.3,472,412.2,513.6,410.5,531.2z"
                        />
                        <g id="spokes_00000123442359669196765780000002385653193711565235_">
                            <path
                                class="st7"
                                d="M413.1,236.7C360.8,105.3,289,100.2,289,100.2l-51.1,13.2c15.2-3.3,48.2,13.1,82.6,54.5
                            c36.8,44.4,75.2,117.7,94.9,226.4c28.1,155-8.2,199.7-29.2,212.5c0.2,0,0.4-0.1,0.6-0.1c1.1-0.1,2.3,0,3.4,0.1l50.5-14.9
                            C504.1,507.9,465.5,368,413.1,236.7z"
                            />
                            <g>
                                <rect x="266.3" y="112.5" transform="matrix(0.9627 -0.2705 0.2705 0.9627 -19.9975 82.5882)" class="st8" width="46.6" height="2.7" />
                            </g>
                            <g>
                                <rect x="287.5" y="127" transform="matrix(0.957 -0.29 0.29 0.957 -23.8478 95.7118)" class="st8" width="47" height="2.7" />
                            </g>
                            <g>
                                <rect x="307.6" y="146.2" transform="matrix(0.9604 -0.2788 0.2788 0.9604 -27.981 98.2529)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="346.2" y="204.8" transform="matrix(0.9602 -0.2792 0.2792 0.9602 -42.8341 111.5244)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="364.3" y="240.6" transform="matrix(0.9602 -0.2792 0.2792 0.9602 -52.121 118.0275)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="381.7" y="281.9" transform="matrix(0.9602 -0.2792 0.2792 0.9602 -62.9652 124.5069)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="395.5" y="323.8" transform="matrix(0.9602 -0.2792 0.2792 0.9602 -74.1203 130.0256)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="407.5" y="366.5" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -85.5803 135.1404)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="416.8" y="409.9" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -97.348 139.4714)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="422.1" y="449.9" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -108.3022 142.5517)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="422.8" y="490.1" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -119.4995 144.3352)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="418.8" y="524.7" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -129.3361 144.5977)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="413.4" y="553.5" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -137.5905 144.2372)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="404" y="577.5" transform="matrix(0.9602 -0.2794 0.2794 0.9602 -144.6616 142.5866)" class="st8" width="47.7" height="2.7" />
                            </g>
                            <g>
                                <rect x="223.2" y="152.1" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -31.923 70.6878)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="216.4" y="172.4" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -37.5612 69.6113)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="211.1" y="199" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -44.8289 69.1528)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="210.5" y="229.7" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -52.9944 70.0788)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="210.6" y="264" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -62.0923 71.3513)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="216" y="300.5" transform="matrix(0.9641 -0.2656 0.2656 0.9641 -71.6086 74.1045)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="222.7" y="340.5" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -82.0183 77.3511)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="232.6" y="381.2" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -92.4857 81.4471)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="245.9" y="419.9" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -102.2723 86.3756)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="261.3" y="454" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -110.794 91.6883)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="276" y="488.7" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -119.4708 96.8271)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="293.3" y="519.3" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -126.9898 102.5302)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="308.6" y="544.3" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -133.0829 107.4891)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="327.2" y="563" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -137.3683 113.1152)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="343.6" y="574.5" transform="matrix(0.9641 -0.2657 0.2657 0.9641 -139.8484 117.8864)" class="st8" width="44.4" height="2.7" />
                            </g>
                            <g>
                                <rect x="328.2" y="173.1" transform="matrix(0.9602 -0.2792 0.2792 0.9602 -34.6942 105.247)" class="st8" width="47.7" height="2.7" />
                            </g>
                        </g>
                    </g>
                    <g id="wheel-eyes_00000120537004185083707940000009387785767432043679_">
                        <g id="big-eye_00000159471247655900284730000003434156515407176639_">
                            <path class="st29" d="M383.3,267.1c0,0,2.7-10.5,12.7-13.4s18.5,4,18.5,4s-3.2,10.5-13.1,13.4S383.3,267.1,383.3,267.1z" />
                            <circle class="st5" cx="399" cy="262.3" r="7.1" />
                            <circle class="st6" cx="399" cy="262.3" r="4.9" />
                        </g>
                        <g id="big-eye_00000013896296393123289930000010650915532815486863_">
                            <path
                                class="st29"
                                d="M398.4,309.2c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S398.4,309.2,398.4,309.2z
                            "
                            />
                            <circle class="st5" cx="414.2" cy="304.4" r="7.1" />
                            <circle class="st6" cx="414.2" cy="304.4" r="4.9" />
                        </g>
                        <g id="big-eye_00000060721101341272742490000002028960396934673305_">
                            <path
                                class="st29"
                                d="M411.8,351.5c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S411.8,351.5,411.8,351.5z
                            "
                            />
                            <circle class="st5" cx="427.6" cy="346.7" r="7.1" />
                            <circle class="st6" cx="427.6" cy="346.7" r="4.9" />
                        </g>
                        <g id="big-eye_00000057849374654373139670000014788844312985393083_">
                            <path class="st29" d="M421.9,395.5c0,0,2.6-10.6,12.5-13.5s18.6,3.7,18.6,3.7s-3.1,10.6-13,13.5S421.9,395.5,421.9,395.5z" />
                            <circle class="st5" cx="437.6" cy="390.5" r="7.1" />
                            <circle class="st6" cx="437.6" cy="390.5" r="4.9" />
                        </g>
                        <g id="big-eye_00000130616537279510342670000008211096270427546540_">
                            <path
                                class="st29"
                                d="M427.5,437.2c0,0,2.6-10.6,12.5-13.5c9.9-2.9,18.6,3.7,18.6,3.7s-3.1,10.6-13,13.5
                            C435.7,444,427.5,437.2,427.5,437.2z"
                            />
                            <circle class="st5" cx="443.2" cy="432.2" r="7.1" />
                            <circle class="st6" cx="443.2" cy="432.2" r="4.9" />
                        </g>
                        <g id="big-eye_00000039831032424758341390000001587982886664220857_">
                            <path
                                class="st30"
                                d="M430.4,477.8c0,0,2.9-9.6,12.8-12.5s18.3,2.8,18.3,2.8s-3.4,9.6-13.3,12.6
                            C438.4,483.6,430.4,477.8,430.4,477.8z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -116.0977 146.4931)" class="st5" cx="446.2" cy="472.8" rx="7.1" ry="6.4" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -116.0977 146.4931)" class="st6" cx="446.2" cy="472.8" rx="4.9" ry="4.3" />
                        </g>
                        <g id="big-eye_00000116218279240901012300000016675070507997218708_">
                            <path
                                class="st31"
                                d="M432.2,513.8c0,0,3.2-8.6,13.1-11.5s18,1.9,18,1.9s-3.7,8.6-13.6,11.6
                            C439.9,518.7,432.2,513.8,432.2,513.8z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -126.2948 148.5001)" class="st5" cx="448" cy="508.9" rx="7.1" ry="5.6" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -126.2948 148.5001)" class="st6" cx="448" cy="508.9" rx="4.9" ry="3.8" />
                        </g>
                        <g id="big-eye_00000155108321864006349270000005039416774954246329_">
                            <path
                                class="st32"
                                d="M429.2,546c0,0,3.5-7.4,13.4-10.4c9.9-2.9,17.7,0.8,17.7,0.8s-4,7.5-13.9,10.4
                            C436.5,549.8,429.2,546,429.2,546z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -135.5835 148.9622)" class="st5" cx="444.9" cy="541.1" rx="7.1" ry="4.6" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -135.5835 148.9622)" class="st6" cx="444.9" cy="541.1" rx="4.9" ry="3.2" />
                        </g>
                        <g id="big-eye_00000089534772902126876610000012574830715208353680_">
                            <path
                                class="st33"
                                d="M421.8,571.2c0,0,4.1-5.4,14.1-8.3c9.9-2.9,17.1-1.2,17.1-1.2s-4.6,5.4-14.5,8.4
                            C428.6,573,421.8,571.2,421.8,571.2z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -143.0633 147.9112)" class="st5" cx="437.6" cy="566.4" rx="7.1" ry="3" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -143.0633 147.9112)" class="st6" cx="437.6" cy="566.4" rx="4.9" ry="2.1" />
                        </g>
                        <g id="big-eye_00000178903469558729526300000000506880340189317566_">
                            <path
                                class="st34"
                                d="M411.4,591.9c0,0,4.4-4.5,14.3-7.5c9.9-2.9,16.9-2,16.9-2s-4.9,4.6-14.7,7.6
                            C417.9,593,411.4,591.9,411.4,591.9z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -149.406 145.804)" class="st5" cx="427.1" cy="587.1" rx="7.1" ry="2.4" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -149.406 145.804)" class="st6" cx="427.1" cy="587.1" rx="4.9" ry="1.6" />
                        </g>
                        <g id="big-eye_00000016075591525356541710000004309207982768954516_">
                            <path
                                class="st35"
                                d="M347.5,193.8c0,0,3-9.4,12.9-12.3c9.9-2.9,18.2,2.6,18.2,2.6s-3.5,9.4-13.3,12.3
                            C355.4,199.4,347.5,193.8,347.5,193.8z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -38.7351 111.1505)" class="st5" cx="363.2" cy="188.9" rx="7.1" ry="6.2" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -38.7351 111.1505)" class="st6" cx="363.2" cy="188.9" rx="4.9" ry="4.2" />
                        </g>
                        <g id="big-eye_00000142167241762655330560000005917074515593068432_">
                            <path class="st29" d="M365.1,228.9c0,0,2.6-10.6,12.5-13.5s18.6,3.7,18.6,3.7s-3.1,10.6-13,13.5S365.1,228.9,365.1,228.9z" />
                            <circle class="st5" cx="380.8" cy="224" r="7.1" />
                            <circle class="st6" cx="380.8" cy="224" r="4.9" />
                        </g>
                        <g id="big-eye_00000155137864619017534630000002641914817438060702_">
                            <path
                                class="st36"
                                d="M327.6,165c0,0,3.2-8.6,13.1-11.5c9.9-2.9,18,1.9,18,1.9s-3.7,8.6-13.5,11.6
                            C335.3,169.9,327.6,165,327.6,165z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -31.3564 104.3108)" class="st5" cx="343.3" cy="160.1" rx="7.1" ry="5.6" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -31.3564 104.3108)" class="st6" cx="343.3" cy="160.1" rx="4.9" ry="3.8" />
                        </g>
                        <g id="big-eye_00000010286670793711211320000010241540037101710488_">
                            <path
                                class="st37"
                                d="M308.5,141.4c0,0,3.5-7.6,13.4-10.6c9.9-2.9,17.7,0.9,17.7,0.9s-4,7.7-13.8,10.6
                            C315.9,145.4,308.5,141.4,308.5,141.4z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -25.4435 97.9009)" class="st5" cx="324.2" cy="136.5" rx="7.1" ry="4.8" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -25.4435 97.9009)" class="st6" cx="324.2" cy="136.5" rx="4.9" ry="3.3" />
                        </g>
                        <g id="big-eye_00000013904854717979874430000006286019977663894421_">
                            <path
                                class="st38"
                                d="M288.7,124.8c0,0,4-5.9,13.9-8.8s17.2-0.7,17.2-0.7s-4.5,5.9-14.4,8.9
                            C295.7,127.1,288.7,124.8,288.7,124.8z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -21.5439 91.5915)" class="st5" cx="304.5" cy="119.9" rx="7.1" ry="3.4" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -21.5439 91.5915)" class="st6" cx="304.5" cy="119.9" rx="4.9" ry="2.3" />
                        </g>
                        <g id="big-eye_00000009556896567230441590000010127650865724992691_">
                            <path
                                class="st39"
                                d="M266.9,113.8c0,0,4.5-4.3,14.4-7.2c9.9-2.9,16.8-2.2,16.8-2.2s-5,4.3-14.8,7.3
                            C273.4,114.7,266.9,113.8,266.9,113.8z"
                            />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -19.353 84.9332)" class="st5" cx="282.6" cy="109.1" rx="7.1" ry="2.1" />

                            <ellipse transform="matrix(0.9587 -0.2845 0.2845 0.9587 -19.353 84.9332)" class="st6" cx="282.6" cy="109.1" rx="4.9" ry="1.5" />
                        </g>
                        <g id="big-eye_00000106126030215068387520000011507794917660537489_">
                            <path
                                class="st29"
                                d="M235.9,367.2c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S235.9,367.2,235.9,367.2z
                            "
                            />
                            <circle class="st5" cx="251.6" cy="362.4" r="7.1" />
                            <circle class="st6" cx="251.6" cy="362.4" r="4.9" />
                        </g>
                        <g id="big-eye_00000089549739035116404360000002235153804818378921_">
                            <path
                                class="st29"
                                d="M246.5,405.9c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S246.5,405.9,246.5,405.9z
                            "
                            />
                            <circle class="st5" cx="262.3" cy="401.1" r="7.1" />
                            <circle class="st6" cx="262.3" cy="401.1" r="4.9" />
                        </g>
                        <g id="big-eye_00000029731727459278001420000002757009464665558918_">
                            <path class="st29" d="M260,443.4c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S260,443.4,260,443.4z" />
                            <circle class="st5" cx="275.8" cy="438.7" r="7.1" />
                            <circle class="st6" cx="275.8" cy="438.7" r="4.9" />
                        </g>
                        <g id="big-eye_00000134223855013208943810000011796318171488596376_">
                            <path
                                class="st29"
                                d="M273.9,476.8c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4S273.9,476.8,273.9,476.8z
                            "
                            />
                            <circle class="st5" cx="289.7" cy="472.1" r="7.1" />
                            <circle class="st6" cx="289.7" cy="472.1" r="4.9" />
                        </g>
                        <g id="big-eye_00000037656008052904229860000007696441666244266126_">
                            <path
                                class="st29"
                                d="M224,325.5c0,0,2.7-10.5,12.7-13.4c9.9-2.8,18.5,4,18.5,4s-3.2,10.5-13.1,13.4
                            C232.2,332.4,224,325.5,224,325.5z"
                            />
                            <circle class="st5" cx="239.8" cy="320.8" r="7.1" />
                            <circle class="st6" cx="239.8" cy="320.8" r="4.9" />
                        </g>
                        <g id="big-eye_00000065071949613522971230000014894943370546677142_">
                            <path
                                class="st40"
                                d="M219.3,288c0,0,3.2-8.7,13.2-11.5c9.9-2.8,18,2.2,18,2.2s-3.8,8.7-13.7,11.5
                            C227,293.1,219.3,288,219.3,288z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -68.3207 74.8409)" class="st5" cx="235.1" cy="283.3" rx="7.1" ry="5.7" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -68.3207 74.8409)" class="st6" cx="235.1" cy="283.3" rx="4.9" ry="3.9" />
                        </g>
                        <g id="big-eye_00000107557855741270567860000007018979587169887904_">
                            <path
                                class="st40"
                                d="M217.1,252.9c0,0,3.2-8.7,13.2-11.5c9.9-2.8,18,2.2,18,2.2s-3.8,8.7-13.7,11.5
                            C224.7,258,217.1,252.9,217.1,252.9z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -58.8336 72.8844)" class="st5" cx="232.8" cy="248.1" rx="7.1" ry="5.7" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -58.8336 72.8844)" class="st6" cx="232.8" cy="248.1" rx="4.9" ry="3.9" />
                        </g>
                        <g id="big-eye_00000143612145104821290690000016536495676157354884_">
                            <path
                                class="st41"
                                d="M217.8,221.8c0,0,3.4-8.1,13.4-10.9c9.9-2.8,17.9,1.7,17.9,1.7s-3.9,8.1-13.8,11
                            C225.3,226.3,217.8,221.8,217.8,221.8z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -50.3335 71.8994)" class="st5" cx="233.5" cy="217.1" rx="7.1" ry="5.2" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -50.3335 71.8994)" class="st6" cx="233.5" cy="217.1" rx="4.9" ry="3.6" />
                        </g>
                        <g id="big-eye_00000021831701105498432550000012564757442415898768_">
                            <path
                                class="st42"
                                d="M219.9,192.2c0,0,3.9-6.5,13.8-9.4c9.9-2.8,17.5,0.2,17.5,0.2s-4.4,6.6-14.3,9.4
                            C227,195.3,219.9,192.2,219.9,192.2z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -42.2095 71.3776)" class="st5" cx="235.7" cy="187.6" rx="7.1" ry="4" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -42.2095 71.3776)" class="st6" cx="235.7" cy="187.6" rx="4.9" ry="2.7" />
                        </g>
                        <g id="big-eye_00000129193564137245938780000017306214618637199025_">
                            <path
                                class="st43"
                                d="M223.9,167.8c0,0,4.2-5.3,14.2-8.1c9.9-2.8,17.1-1,17.1-1s-4.7,5.3-14.6,8.2
                            C230.6,169.7,223.9,167.8,223.9,167.8z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -35.4213 71.5289)" class="st5" cx="239.7" cy="163.2" rx="7.1" ry="3" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -35.4213 71.5289)" class="st6" cx="239.7" cy="163.2" rx="4.9" ry="2" />
                        </g>
                        <g id="big-eye_00000180335484300054605580000005000127641027494580_">
                            <path class="st44" d="M234,150c0,0,4.5-4.3,14.4-7.1c9.9-2.8,16.9-1.9,16.9-1.9s-5,4.4-14.9,7.2S234,150,234,150z" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -30.1823 73.6178)" class="st5" cx="249.8" cy="145.4" rx="7.1" ry="2.2" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -30.1823 73.6178)" class="st6" cx="249.8" cy="145.4" rx="4.9" ry="1.5" />
                        </g>
                        <g id="big-eye_00000124853456449345243500000003094415036607928490_">
                            <path class="st45" d="M292,511c0,0,3.3-8.5,13.2-11.3c9.9-2.8,18,2,18,2s-3.8,8.5-13.7,11.4C299.6,516,292,511,292,511z" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -126.3884 103.1018)" class="st5" cx="307.8" cy="506.3" rx="7.1" ry="5.5" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -126.3884 103.1018)" class="st6" cx="307.8" cy="506.3" rx="4.9" ry="3.8" />
                        </g>
                        <g id="big-eye_00000151521120580187423820000012127486467155493275_">
                            <path
                                class="st46"
                                d="M309.8,536.8c0,0,3.6-7.5,13.5-10.3s17.7,1.1,17.7,1.1s-4.1,7.5-14,10.4
                            C317.2,540.8,309.8,536.8,309.8,536.8z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -132.7585 108.935)" class="st5" cx="325.6" cy="532.2" rx="7.1" ry="4.7" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -132.7585 108.935)" class="st6" cx="325.6" cy="532.2" rx="4.9" ry="3.2" />
                        </g>
                        <g id="big-eye_00000124848575770925772690000011893449183262379951_">
                            <path
                                class="st47"
                                d="M327.9,558.3c0,0,3.9-6.3,13.9-9.1c9.9-2.8,17.4-0.1,17.4-0.1s-4.4,6.3-14.3,9.2S327.9,558.3,327.9,558.3z
                            "
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -137.9423 114.6777)" class="st5" cx="343.7" cy="553.7" rx="7.1" ry="3.8" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -137.9423 114.6777)" class="st6" cx="343.7" cy="553.7" rx="4.9" ry="2.6" />
                        </g>
                        <g id="big-eye_00000009582404851771480290000014389018343087108783_">
                            <path
                                class="st48"
                                d="M345.3,573.6c0,0,4.5-4.4,14.4-7.2s16.9-1.9,16.9-1.9s-5,4.5-14.9,7.3
                            C351.9,574.6,345.3,573.6,345.3,573.6z"
                            />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -141.4483 120.0277)" class="st5" cx="361.2" cy="569" rx="7.1" ry="2.3" />

                            <ellipse transform="matrix(0.9621 -0.2727 0.2727 0.9621 -141.4483 120.0277)" class="st6" cx="361.2" cy="569" rx="4.9" ry="1.5" />
                        </g>
                    </g>
                </g>
                <g>
                    <defs>
                        <path
                            id="SVGID_1_"
                            d="M111,208.8v301.5H557V208.8H111z M350.7,237.2c4.2-1.7,8.1-3.3,11.9-4.8c14.6-5.9,28.9-10.6,42.6-14.2
                        c2.7,5.9,5.3,12.1,7.9,18.6c4.2,10.6,8.4,21.3,12.4,32c-16.5,4-34.5,9.8-53.6,17.1C365.7,270,358.7,253.4,350.7,237.2z
                        M456.4,407.6c-1.6,1.3-3.1,2.5-4.5,3.6c-6.2,5-10.4,8.2-16.1,12.3c-4.7,2.8-9.6,5.4-14.6,7.9c-0.1-1-0.2-1.9-0.4-2.9
                        c-0.3,0.1-0.7,0.2-1,0.2c0.1,1.1,0.3,2.2,0.4,3.2c-2.5,1.2-5,2.4-7.5,3.6c-1,0.5-1.9,0.9-2.9,1.4c-0.8-7.7-1.7-15.8-2.9-24.3
                        c-1.4-10.2-3.4-21-5.7-32c18.8-10.7,35.6-22.2,50.4-34.1c5.3,18.3,9.8,36.4,13.4,54.1C462.2,402.8,459.3,405.1,456.4,407.6z"
                        />
                    </defs>
                    <clipPath id="SVGID_00000035505482682570252540000001336612525050083201_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    </clipPath>

                    <g class="space-wbeel" id="wheel-outer_00000022538728818554435290000014783285760447364760_" style="clip-path:url(#SVGID_00000035505482682570252540000001336612525050083201_);">
                        <g id="wheel-outer_00000033348397673325876320000004755831320176855436_">
                            <path
                                class="st7"
                                d="M352.6,447.5c2.6,0.1,5.6,0.5,7.1,2.7c1.4,2.1,0.8,5.1-0.7,7c-1.6,2-3.9,3.2-6.2,4.3
                            c-20.2,10.2-41,19.1-62.3,26.7c-14.3,5.1-29.7,9.7-44.6,6.5c-3.4-0.7-7.2-2.4-7.9-5.8c-0.8-4.1,3.5-7.2,7.1-9.1
                            c14.8-8,29.6-16,44.4-24c5.2-2.8,10.4-5.6,16.1-7.1c8-2.1,13.4,1.8,20.8,1.9C335.1,450.7,343.7,447.2,352.6,447.5z"
                            />
                            <path
                                class="st7"
                                d="M454.6,243.3c2.9-0.8,6,1.9,6.3,4.9s-1.6,5.9-4.1,7.7c-2.5,1.7-5.5,2.6-8.4,3.4
                            c-13.2,3.6-26.2,7.6-39.2,11.9c-11.6,3.9-23.1,8-34.6,12.1c-8.3,3-16.5,5.9-24.8,8.9c-11,4-22,7.9-33,11.9
                            c-12.8,4.6-20.8,16.8-34.2,18.9c-2.9,0.5-6.3,0.6-8.4-1.5c-2.2-2.1-2.1-5.7-0.7-8.4c1.4-2.7,3.9-4.5,6.4-6.3
                            c36.9-26.7,77.8-47.4,118.6-68c7.8-3.9,15.9-7.9,24.6-8C433.9,230.7,445.5,237.4,454.6,243.3z"
                            />
                            <path
                                class="st7"
                                d="M448.7,408.4c6.4-5.6,12.8-11.1,19.3-16.7c2.1-1.8,4.3-3.9,4.9-6.6c0.9-4.6-3.7-8.7-8.3-9.2
                            s-9.1,1.7-13.2,4c-22.7,12.3-43.7,27.8-62.2,45.9c-3,2.9-6.1,7.1-4.4,10.9c2,4.2,8.1,3.9,12.5,2.4c12-4.1,22.7-12.1,30-22.4"
                            />
                            <path
                                class="st7"
                                d="M514.3,266.1c0,0-12.4,60.3-119.7,119.2S235,452.4,235,452.4s-5.9,6.6-76.8-0.4c0,0-1.7,29.1,16.5,38.1
                            c0,0,24.1,15.2,68.4,3.8c44.3-11.4,121.4-38.8,162.3-64.2c41-25.4,93.6-65.7,118.1-104C548,287.4,527,270.5,514.3,266.1z"
                            />
                            <path
                                class="st8"
                                d="M153.7,421.1c-2.9,3.7-4,5.7-6.8,11.3c-8,16.3-14,41.9-0.2,58.6c28.9,34.9,117.1,8.4,158.1-6.8
                            c32.1-12.3,64.5-29.1,95.1-43.8c11.8-6,24.1-11.2,35.1-17.9c7-4.9,11.4-8.5,20.6-15.8c44-35.7,158.5-133.6,61.1-156.3
                            c-60.1-11.2-142.5,21.7-194.7,45.7l-0.1,0.1c-25.4,11-56.5,29-80.4,46.1C192.9,377,165.2,407.8,153.7,421.1z M251.7,347
                            c21.8-15.7,50.1-32.1,73.1-42.2l0.1-0.1c47.4-22,122.2-52.3,176.7-42.4c88.1,20-16.2,109.3-56.2,141.9
                            c-8.3,6.6-12.4,10-18.7,14.4c-10,6.1-21.2,10.9-31.9,16.4c-27.8,13.4-57.3,28.9-86.5,40.2c-37.2,14-117.3,38.4-143.3,7
                            c-12.5-15.1-6.9-38.3,0.5-53.1c2.5-5.1,3.5-6.9,6.2-10.3C182.1,406.7,207.4,378.6,251.7,347z"
                            />
                            <g id="spokes_00000049910779135157911970000007602341762518675120_">
                                <path
                                    class="st7"
                                    d="M362.9,233.2c118.9-47.8,167.3-4.3,167.3-4.3l23.5,41.5c-7.4-12-38.8-23.3-87.5-19.8
                                c-52.2,3.7-124.3,24.4-207.8,79.4c-119.2,78.4-125.7,130-120.9,151.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.7-0.8-1.4-1.5-2.2-2.2
                                L113,436.9C128.2,343.2,244,281.1,362.9,233.2z"
                                />
                                <g>
                                    <polygon class="st8" points="529.7,256.2 531.9,255 512,217.9 509.8,219 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="506.6,251.6 508.7,250.5 489.4,212.7 487.3,213.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="481.5,250.5 483.7,249.3 463.6,211.2 461.5,212.3 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="418.9,261.9 421.1,260.8 401,222.6 398.9,223.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="384,272.4 386.2,271.3 366.1,233.1 364,234.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="346.1,286.9 348.3,285.8 328.2,247.6 326.1,248.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="310,304.1 312.1,303 292.1,264.8 290,265.9 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="274.5,322.9 276.7,321.7 256.6,283.6 254.5,284.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="240.2,343.9 242.4,342.8 222.3,304.6 220.2,305.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="210.7,365.4 212.8,364.3 192.8,326.1 190.7,327.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="184,390 186.1,388.9 166.1,350.7 163.9,351.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="163.8,414.2 165.9,413.1 145.9,374.9 143.7,376 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="148.3,435.7 150.4,434.6 130.4,396.4 128.3,397.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="138.4,456.7 140.6,455.6 120.5,417.4 118.4,418.6 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="531.2,308.7 533.3,307.6 514.2,272.3 512.1,273.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="522.1,325.8 524.3,324.7 505.1,289.4 503,290.6 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="508,345.9 510.2,344.8 491,309.5 488.9,310.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="488.4,365.5 490.5,364.3 471.4,329.1 469.2,330.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="465.8,386.8 467.9,385.6 448.8,350.4 446.7,351.5 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="438.4,406.1 440.6,404.9 421.4,369.7 419.3,370.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="408.1,426.7 410.2,425.5 391.1,390.3 388.9,391.4 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="375.2,445.6 377.3,444.5 358.2,409.2 356,410.4 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="341.5,461.1 343.6,459.9 324.5,424.7 322.4,425.8 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="309.5,472.4 311.6,471.2 292.5,436 290.3,437.1 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="277.6,484.4 279.7,483.3 260.6,448 258.4,449.2 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="246.6,492.3 248.8,491.1 229.6,455.9 227.5,457 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="220.7,497.9 222.8,496.8 203.7,461.5 201.5,462.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="196.7,497.4 198.9,496.2 179.7,461 177.6,462.1 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="178.9,493.9 181,492.8 161.9,457.5 159.8,458.7 						" />
                                </g>
                                <g>
                                    <polygon class="st8" points="451,253.8 453.1,252.7 433.1,214.5 430.9,215.6 						" />
                                </g>
                            </g>
                        </g>
                        <g id="wheel-eyes_00000036949500199876157520000005842046873047988136_">
                            <g id="big-eye_00000027598492634118495680000006738977554916416669_">
                                <path
                                    class="st9"
                                    d="M361.7,271.7c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C352.1,270.6,361.7,271.7,361.7,271.7z"
                                />
                                <ellipse class="st5" cx="354.9" cy="258.4" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="354.9" cy="258.4" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000077321124890319137160000005512308326752445343_">
                                <path
                                    class="st9"
                                    d="M324.6,288c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C315,287,324.6,288,324.6,288z"
                                />
                                <ellipse class="st5" cx="317.9" cy="274.8" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="317.9" cy="274.8" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000172408047831024022590000010306971648738718082_">
                                <path
                                    class="st9"
                                    d="M288.5,305.8c0,0,5.2-8.4,0.8-16.6s-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C278.9,304.7,288.5,305.8,288.5,305.8z"
                                />
                                <ellipse class="st5" cx="281.8" cy="292.5" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="281.8" cy="292.5" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000044161959177089334250000009996667623419148946_">
                                <path class="st9" d="M253.4,326.6c0,0,5.3-8.3,1-16.6s-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9S253.4,326.6,253.4,326.6z" />
                                <ellipse class="st5" cx="246.8" cy="313.3" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="246.8" cy="313.3" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000089575077649145631920000012243663525337966011_">
                                <path class="st9" d="M222.5,349c0,0,5.3-8.3,1-16.6s-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9S222.5,349,222.5,349z" />
                                <ellipse class="st5" cx="215.9" cy="335.7" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="215.9" cy="335.7" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000077317986053195744470000009590428322817258150_">
                                <path
                                    class="st10"
                                    d="M194.1,372.4c0,0,4.5-7.9,0.2-16.2S181,346.1,181,346.1s-4.2,8.2,0.1,16.5
                                C185.3,370.8,194.1,372.4,194.1,372.4z"
                                />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -148.1252 132.2404)" class="st5" cx="187.5" cy="359.1" rx="5.8" ry="6.4" />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -148.1252 132.2404)" class="st6" cx="187.5" cy="359.1" rx="3.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000116922596611796354810000005618465817860034954_">
                                <path
                                    class="st11"
                                    d="M169.3,393.7c0,0,3.6-7.4-0.7-15.7c-4.3-8.3-12.5-10.6-12.5-10.6s-3.3,7.8,0.9,16.1
                                C161.3,391.8,169.3,393.7,169.3,393.7z"
                                />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -158.4625 119.558)" class="st5" cx="162.7" cy="380.4" rx="5" ry="6.4" />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -158.4625 119.558)" class="st6" cx="162.7" cy="380.4" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000021095401409881825370000000037939049571521694_">
                                <path
                                    class="st12"
                                    d="M150.2,415.8c0,0,2.7-6.9-1.6-15.2c-4.3-8.3-11.6-11-11.6-11s-2.4,7.3,1.9,15.6
                                C143.1,413.4,150.2,415.8,150.2,415.8z"
                                />

                                <ellipse transform="matrix(0.8866 -0.4625 0.4625 0.8866 -169.885 112.007)" class="st5" cx="143.5" cy="402.5" rx="4.2" ry="6.4" />

                                <ellipse transform="matrix(0.8866 -0.4625 0.4625 0.8866 -169.885 112.007)" class="st6" cx="143.5" cy="402.5" rx="2.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000059271522654654221870000012245218390055875234_">
                                <path
                                    class="st13"
                                    d="M138.3,436.3c0,0,0.9-6-3.4-14.3c-4.3-8.3-10-11.9-10-11.9s-0.7,6.4,3.6,14.7
                                C132.9,433,138.3,436.3,138.3,436.3z"
                                />

                                <ellipse transform="matrix(0.8877 -0.4604 0.4604 0.8877 -179.9963 108.101)" class="st5" cx="131.6" cy="423" rx="2.7" ry="6.4" />

                                <ellipse transform="matrix(0.8877 -0.4604 0.4604 0.8877 -179.9963 108.101)" class="st6" cx="131.6" cy="423" rx="1.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000160880323185128021120000017880459444072392623_">
                                <path
                                    class="st14"
                                    d="M131.3,456.1c0,0,0.2-5.7-4.1-14c-4.3-8.3-9.3-12.2-9.3-12.2s0,6.1,4.3,14.3
                                C126.5,452.5,131.3,456.1,131.3,456.1z"
                                />

                                <ellipse transform="matrix(0.8879 -0.46 0.46 0.8879 -189.7461 106.9319)" class="st5" cx="124.5" cy="442.8" rx="2.1" ry="6.4" />

                                <ellipse transform="matrix(0.8879 -0.46 0.46 0.8879 -189.7461 106.9319)" class="st6" cx="124.5" cy="442.8" rx="1.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000074431898547512061680000014856693811569335716_">
                                <path
                                    class="st15"
                                    d="M432.2,249.3c0,0,4.3-7.8,0-16.1S419,222.9,419,222.9s-4,8.1,0.3,16.4
                                C423.6,247.6,432.2,249.3,432.2,249.3z"
                                />

                                <ellipse transform="matrix(0.8818 -0.4715 0.4715 0.8818 -60.9796 228.5484)" class="st5" cx="425.6" cy="236" rx="5.6" ry="6.4" />

                                <ellipse transform="matrix(0.8818 -0.4715 0.4715 0.8818 -60.9796 228.5484)" class="st6" cx="425.6" cy="236" rx="3.8" ry="4.4" />
                            </g>
                            <g id="big-eye_00000135649326822606542850000012982084372555497643_">
                                <path
                                    class="st9"
                                    d="M398.1,259.7c0,0,5.3-8.3,1-16.6c-4.3-8.3-14.1-9.8-14.1-9.8s-5,8.6-0.7,16.9
                                C388.5,258.5,398.1,259.7,398.1,259.7z"
                                />
                                <ellipse class="st5" cx="391.5" cy="246.3" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="391.5" cy="246.3" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000124841354211647513520000015591754705773188029_">
                                <path
                                    class="st16"
                                    d="M463.5,244.2c0,0,3.6-7.4-0.6-15.7s-12.5-10.6-12.5-10.6s-3.3,7.8,0.9,16.1
                                C455.5,242.3,463.5,244.2,463.5,244.2z"
                                />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -54.9633 239.415)" class="st5" cx="456.9" cy="230.9" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8849 -0.4658 0.4658 0.8849 -54.9633 239.415)" class="st6" cx="456.9" cy="230.9" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000001624267905914961600000011706933269802579597_">
                                <path class="st17" d="M491,242c0,0,2.8-7-1.5-15.3c-4.3-8.3-11.7-11-11.7-11s-2.5,7.4,1.7,15.6C483.7,239.6,491,242,491,242z" />

                                <ellipse transform="matrix(0.8864 -0.4628 0.4628 0.8864 -50.8336 250.1219)" class="st5" cx="484.3" cy="228.7" rx="4.3" ry="6.4" />

                                <ellipse transform="matrix(0.8864 -0.4628 0.4628 0.8864 -50.8336 250.1219)" class="st6" cx="484.3" cy="228.7" rx="3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000163065718636586458000000002473689388981531832_">
                                <path
                                    class="st18"
                                    d="M514.3,244.5c0,0,1.3-6.3-3-14.6c-4.3-8.3-10.4-11.7-10.4-11.7s-1.1,6.6,3.2,14.9
                                S514.3,244.5,514.3,244.5z"
                                />

                                <ellipse transform="matrix(0.8875 -0.4607 0.4607 0.8875 -49.4353 259.8502)" class="st5" cx="507.6" cy="231.2" rx="3.1" ry="6.4" />

                                <ellipse transform="matrix(0.8875 -0.4607 0.4607 0.8875 -49.4353 259.8502)" class="st6" cx="507.6" cy="231.2" rx="2.1" ry="4.4" />
                            </g>
                            <g id="big-eye_00000113326396288094630970000002590243936875823783_">
                                <path
                                    class="st19"
                                    d="M535.1,251.9c0,0,0-5.6-4.3-13.9c-4.3-8.3-9.1-12.3-9.1-12.3s0.3,5.9,4.5,14.2
                                C530.5,248.2,535.1,251.9,535.1,251.9z"
                                />

                                <ellipse transform="matrix(0.8879 -0.4599 0.4599 0.8879 -50.5479 269.7663)" class="st5" cx="528.4" cy="238.6" rx="1.9" ry="6.4" />

                                <ellipse transform="matrix(0.8879 -0.4599 0.4599 0.8879 -50.5479 269.7663)" class="st6" cx="528.4" cy="238.6" rx="1.3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000175283376485096664830000009865184259227151756_">
                                <path
                                    class="st9"
                                    d="M388.6,430.2c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C379,429.1,388.6,430.2,388.6,430.2z"
                                />
                                <ellipse class="st5" cx="381.8" cy="416.9" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="381.8" cy="416.9" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000065767474400979401880000010812818779784882328_">
                                <path
                                    class="st9"
                                    d="M356.6,447.3c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C347,446.3,356.6,447.3,356.6,447.3z"
                                />
                                <ellipse class="st5" cx="349.8" cy="434.1" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="349.8" cy="434.1" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000129890286525617394960000014042796506154355870_">
                                <path
                                    class="st9"
                                    d="M323.5,462c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C313.9,461,323.5,462,323.5,462z"
                                />
                                <ellipse class="st5" cx="316.8" cy="448.8" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="316.8" cy="448.8" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000073689036953483389700000016997256074179154321_">
                                <path
                                    class="st9"
                                    d="M292.9,473.8c0,0,5.2-8.4,0.8-16.6c-4.4-8.2-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C283.3,472.7,292.9,473.8,292.9,473.8z"
                                />
                                <ellipse class="st5" cx="286.1" cy="460.5" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="286.1" cy="460.5" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000132766844846806251690000003492563444558943897_">
                                <path
                                    class="st9"
                                    d="M423.3,411.9c0,0,5.2-8.4,0.8-16.6s-14.2-9.6-14.2-9.6s-4.9,8.7-0.5,16.9
                                C413.7,410.8,423.3,411.9,423.3,411.9z"
                                />
                                <ellipse class="st5" cx="416.6" cy="398.6" rx="6.5" ry="6.4" />
                                <ellipse class="st6" cx="416.6" cy="398.6" rx="4.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000039129520099385929140000017319906806674316967_">
                                <path
                                    class="st20"
                                    d="M450.9,391.5c0,0,3.7-7.5-0.7-15.8c-4.4-8.2-12.8-10.4-12.8-10.4s-3.3,7.9,1,16.1
                                C442.7,389.7,450.9,391.5,450.9,391.5z"
                                />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -126.7256 257.9494)" class="st5" cx="444.1" cy="378.3" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -126.7256 257.9494)" class="st6" cx="444.1" cy="378.3" rx="3.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000144307091952582833840000015532919308937709459_">
                                <path
                                    class="st20"
                                    d="M475.3,371.1c0,0,3.7-7.5-0.7-15.8c-4.4-8.2-12.8-10.4-12.8-10.4s-3.3,7.9,1,16.1
                                C467.2,369.3,475.3,371.1,475.3,371.1z"
                                />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -114.0105 267.1443)" class="st5" cx="468.5" cy="357.9" rx="5.1" ry="6.4" />

                                <ellipse transform="matrix(0.8786 -0.4775 0.4775 0.8786 -114.0105 267.1443)" class="st6" cx="468.5" cy="357.9" rx="3.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000021809366175956850080000008851768369659639443_">
                                <path
                                    class="st21"
                                    d="M495.3,351.2c0,0,3.2-7.3-1.2-15.5s-12.3-10.6-12.3-10.6s-2.9,7.6,1.5,15.9
                                C487.6,349.2,495.3,351.2,495.3,351.2z"
                                />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -101.9452 272.7003)" class="st5" cx="488.4" cy="338" rx="4.7" ry="6.4" />

                                <ellipse transform="matrix(0.8799 -0.4752 0.4752 0.8799 -101.9452 272.7003)" class="st6" cx="488.4" cy="338" rx="3.2" ry="4.4" />
                            </g>
                            <g id="big-eye_00000065037293904274627140000005338653162760751790_">
                                <path
                                    class="st22"
                                    d="M513.3,331.4c0,0,1.9-6.6-2.5-14.8c-4.4-8.2-11.1-11.3-11.1-11.3s-1.6,6.9,2.8,15.2
                                S513.3,331.4,513.3,331.4z"
                                />

                                <ellipse transform="matrix(0.8814 -0.4724 0.4724 0.8814 -90.2383 276.9353)" class="st5" cx="506.4" cy="318.2" rx="3.6" ry="6.4" />

                                <ellipse transform="matrix(0.8814 -0.4724 0.4724 0.8814 -90.2383 276.9353)" class="st6" cx="506.4" cy="318.2" rx="2.5" ry="4.4" />
                            </g>
                            <g id="big-eye_00000106139481252489262490000017001059892089842577_">
                                <path
                                    class="st23"
                                    d="M526.8,313.6c0,0,0.8-6-3.6-14.3c-4.4-8.2-10.1-11.8-10.1-11.8s-0.5,6.4,3.8,14.6
                                C521.3,310.4,526.8,313.6,526.8,313.6z"
                                />

                                <ellipse transform="matrix(0.8819 -0.4714 0.4714 0.8819 -80.2285 280.537)" class="st5" cx="519.9" cy="300.4" rx="2.7" ry="6.4" />

                                <ellipse transform="matrix(0.8819 -0.4714 0.4714 0.8819 -80.2285 280.537)" class="st6" cx="519.9" cy="300.4" rx="1.8" ry="4.4" />
                            </g>
                            <g id="big-eye_00000114069016241598170800000002376295342369779097_">
                                <path
                                    class="st24"
                                    d="M532.1,295.9c0,0,0-5.6-4.4-13.8s-9.3-12.2-9.3-12.2s0.3,6,4.6,14.2C527.4,292.2,532.1,295.9,532.1,295.9
                                z"
                                />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -71.2501 280.6657)" class="st5" cx="525.2" cy="282.7" rx="2" ry="6.4" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -71.2501 280.6657)" class="st6" cx="525.2" cy="282.7" rx="1.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000065752933057650696590000014931983719436951994_">
                                <path
                                    class="st25"
                                    d="M259.2,483.4c0,0,3.5-7.5-0.9-15.7c-4.4-8.2-12.6-10.4-12.6-10.4s-3.2,7.8,1.1,16
                                C251.2,481.5,259.2,483.4,259.2,483.4z"
                                />

                                <ellipse transform="matrix(0.8791 -0.4766 0.4766 0.8791 -193.5661 177.1104)" class="st5" cx="252.4" cy="470.1" rx="5" ry="6.4" />

                                <ellipse transform="matrix(0.8791 -0.4766 0.4766 0.8791 -193.5661 177.1104)" class="st6" cx="252.4" cy="470.1" rx="3.4" ry="4.4" />
                            </g>
                            <g id="big-eye_00000041973799612733067560000010988207683362791582_">
                                <path
                                    class="st26"
                                    d="M231.1,487.9c0,0,2.7-7-1.7-15.3c-4.4-8.2-11.8-10.9-11.8-10.9s-2.4,7.4,2,15.6
                                C223.9,485.6,231.1,487.9,231.1,487.9z"
                                />

                                <ellipse transform="matrix(0.8807 -0.4737 0.4737 0.8807 -198.0951 162.8742)" class="st5" cx="224.3" cy="474.7" rx="4.3" ry="6.4" />

                                <ellipse transform="matrix(0.8807 -0.4737 0.4737 0.8807 -198.0951 162.8742)" class="st6" cx="224.3" cy="474.7" rx="2.9" ry="4.4" />
                            </g>
                            <g id="big-eye_00000021090533672775764180000017633252342171456397_">
                                <path
                                    class="st27"
                                    d="M205.7,489.5c0,0,1.6-6.5-2.8-14.7c-4.4-8.2-10.9-11.4-10.9-11.4s-1.4,6.8,3,15.1
                                C199.4,486.7,205.7,489.5,205.7,489.5z"
                                />

                                <ellipse transform="matrix(0.8815 -0.4721 0.4721 0.8815 -201.3152 150.2825)" class="st5" cx="198.8" cy="476.3" rx="3.4" ry="6.4" />

                                <ellipse transform="matrix(0.8815 -0.4721 0.4721 0.8815 -201.3152 150.2825)" class="st6" cx="198.8" cy="476.3" rx="2.3" ry="4.4" />
                            </g>
                            <g id="big-eye_00000088836798833997574280000016830691995149248406_">
                                <path class="st28" d="M184.7,487.6c0,0,0.1-5.6-4.3-13.9s-9.4-12.2-9.4-12.2s0.2,6,4.6,14.2C180,484,184.7,487.6,184.7,487.6z" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -202.5082 139.6768)" class="st5" cx="177.8" cy="474.5" rx="2.1" ry="6.4" />

                                <ellipse transform="matrix(0.8821 -0.471 0.471 0.8821 -202.5082 139.6768)" class="st6" cx="177.8" cy="474.5" rx="1.4" ry="4.4" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g id="stars">
                <polygon class="st50" points="344.7,66.9 364.5,72 344.7,77 339.6,96.8 334.6,77 314.8,72 334.6,66.9 339.6,47.1 	" />
                <polygon class="st50" points="149.1,145 169,150 149.1,155 144.1,174.9 139.1,155 119.2,150 139.1,145 144.1,125.1 	" />
                <polygon class="st50" points="70.9,339.5 90.7,344.6 70.9,349.6 65.8,369.4 60.8,349.6 40.9,344.6 60.8,339.5 65.8,319.7 	" />
                <polygon
                    class="st50"
                    points="621.1,339.5 641,344.6 621.1,349.6 616.1,369.4 611.1,349.6 591.2,344.6 611.1,339.5 616.1,319.7 	
                "
                />
                <polygon class="st50" points="147.8,533.9 167.6,538.9 147.8,544 142.7,563.8 137.7,544 117.8,538.9 137.7,533.9 142.7,514.1 	" />
                <polygon
                    class="st50"
                    points="541.8,532.8 561.6,537.8 541.8,542.8 536.8,562.7 531.7,542.8 511.9,537.8 531.7,532.8 536.8,512.9 	
                "
                />
                <polygon
                    class="st50"
                    points="346.7,614.8 366.6,619.8 346.7,624.8 341.7,644.7 336.7,624.8 316.8,619.8 336.7,614.8 341.7,594.9 	
                "
                />
                <polygon class="st50" points="543.1,143.8 563,148.9 543.1,153.9 538.1,173.8 533.1,153.9 513.2,148.9 533.1,143.8 538.1,124 	" />
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'badge-1',
    data() {
        return {
            counter: 0,
            intervalId: null,
            doAnimate: false
        }
    },
    mounted() {
        this.intervalId = setInterval(() => {
            this.doAnimate = true
            
            setTimeout(() => {
                this.doAnimate = false
            }, 8000)
        }, 15000)

        this.doAnimate = true
        setTimeout(() => {
            this.doAnimate = false
        }, 5000)
    },
    beforeUnmount() {
        clearInterval(this.intervalId)
    },
}
</script>

<style scoped>

.beyond-bounds {
    overflow: hidden;
}

.beyond-bounds * {
    transition: all 0.4s;
}

@keyframes shifty {
    from {
        transform: translateX(12px);
    }
    to {
        transform: translateX(-12px);
    }
}

.beyond-bounds.animate #eye-color,
.beyond-bounds:hover #eye-color {
    animation: shifty 1s infinite alternate-reverse;
}

.space-wheel, .circ {
    opacity: 0;
}

#stars, .big-eye {
    opacity: 0.3;
}

.beyond-bounds.animate .space-wheel, 
.beyond-bounds.animate .circ, 
.beyond-bounds.animate #stars,
.beyond-bounds.animate .big-eye,
.beyond-bounds:hover .space-wheel, 
.beyond-bounds:hover .circ, 
.beyond-bounds:hover #stars,
.beyond-bounds:hover .big-eye  {
    opacity: 1;
}

@keyframes spin {
    from {
        opacity: 0;
        transform: rotate(300deg);
    }
    t0 {
        transform: rotate(20deg);
    }
}

.beyond-bounds.animate .space-wheel,
.beyond-bounds:hover .space-wheel {
    animation: spin 5s infinite alternate;
    transform-origin: center;
}

.st0{fill:#1D406C;}
.st1{stroke:#ED0000;stroke-width:7.8613;stroke-miterlimit:10;}
.st2{fill:none;stroke:#D8D8D8;stroke-width:5.8564;stroke-miterlimit:10;}
.st3{fill:none;stroke:#D8D8D8;stroke-width:5.3295;stroke-miterlimit:10;}
.st4{fill:#FFFFFF;stroke:#6E787A;stroke-width:3.9971;stroke-miterlimit:10;}
.st5{fill:#DD3F28;}
.st6{fill:#1B1B1B;}
.st7{fill:#806F75;}
.st8{fill:#BBBABD;}
.st9{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.3362;stroke-miterlimit:10;}
.st10{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2616;stroke-miterlimit:10;}
.st11{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.1796;stroke-miterlimit:10;}
.st12{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.0778;stroke-miterlimit:10;}
.st13{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8675;stroke-miterlimit:10;}
.st14{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.7679;stroke-miterlimit:10;}
.st15{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2427;stroke-miterlimit:10;}
.st16{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.181;stroke-miterlimit:10;}
.st17{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.0951;stroke-miterlimit:10;}
.st18{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.9223;stroke-miterlimit:10;}
.st19{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.7297;stroke-miterlimit:10;}
.st20{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.191;stroke-miterlimit:10;}
.st21{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.1423;stroke-miterlimit:10;}
.st22{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.9969;stroke-miterlimit:10;}
.st23{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8611;stroke-miterlimit:10;}
.st24{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.7421;stroke-miterlimit:10;}
.st25{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.176;stroke-miterlimit:10;}
.st26{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.0885;stroke-miterlimit:10;}
.st27{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.9702;stroke-miterlimit:10;}
.st28{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.7535;stroke-miterlimit:10;}
.st29{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.477;stroke-miterlimit:10;}
.st30{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.3946;stroke-miterlimit:10;}
.st31{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.304;stroke-miterlimit:10;}
.st32{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.1914;stroke-miterlimit:10;}
.st33{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.9589;stroke-miterlimit:10;}
.st34{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8489;stroke-miterlimit:10;}
.st35{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.3737;stroke-miterlimit:10;}
.st36{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.3054;stroke-miterlimit:10;}
.st37{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2105;stroke-miterlimit:10;}
.st38{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.0195;stroke-miterlimit:10;}
.st39{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8066;stroke-miterlimit:10;}
.st40{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.3166;stroke-miterlimit:10;}
.st41{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2627;stroke-miterlimit:10;}
.st42{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.102;stroke-miterlimit:10;}
.st43{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.9518;stroke-miterlimit:10;}
.st44{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8203;stroke-miterlimit:10;}
.st45{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2999;stroke-miterlimit:10;}
.st46{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.2032;stroke-miterlimit:10;}
.st47{fill:#FFFFFF;stroke:#6E787A;stroke-width:1.0725;stroke-miterlimit:10;}
.st48{fill:#FFFFFF;stroke:#6E787A;stroke-width:0.8329;stroke-miterlimit:10;}
.st49{clip-path:url(#SVGID_00000078027411042605485570000005197108765270641070_);}
.st50{fill:#FFFFFF;}
</style>